import {MidiTrack} from "./MidiTypes";
import switz from './switzerland.mid';
import lovania from './midilovania.mid';

export interface Song
{
    name: string,
    track: MidiTrack,
    midi: string
}

export const switzerland: Song = {
    name: "switzerland",
    midi: switz,
    track: {
        "header": {
            "keySignatures": [
                {
                    "key": "Bb",
                    "scale": "major",
                    "ticks": 0
                }
            ],
            "meta": [
                {
                    "text": "THE SOFTWARE TOOLWORKS",
                    "ticks": 0,
                    "type": "text"
                },
                {
                    "text": "WORLD ATLAS",
                    "ticks": 0,
                    "type": "text"
                },
                {
                    "text": "MultiMedia Windows Version",
                    "ticks": 0,
                    "type": "text"
                },
                {
                    "text": "Country: SWITZERLAND",
                    "ticks": 0,
                    "type": "text"
                },
                {
                    "text": "(p) (c) The Software Toolworks 1991",
                    "ticks": 0,
                    "type": "text"
                },
                {
                    "text": "revised 11-15-91",
                    "ticks": 0,
                    "type": "text"
                },
                {
                    "text": "edit date:9-11-91",
                    "ticks": 0,
                    "type": "text"
                },
                {
                    "text": "MMWIN EDIT DATE: 9-13-91",
                    "ticks": 0,
                    "type": "text"
                },
                {
                    "text": "This file provided by:",
                    "ticks": 0,
                    "type": "text"
                },
                {
                    "text": "Rob Wallace Music",
                    "ticks": 0,
                    "type": "text"
                },
                {
                    "text": "(602) 979-6201",
                    "ticks": 0,
                    "type": "text"
                }
            ],
            "name": "",
            "ppq": 192,
            "tempos": [
                {
                    "bpm": 60,
                    "ticks": 0
                }
            ],
            "timeSignatures": [
                {
                    "ticks": 0,
                    "timeSignature": [
                        3,
                        4
                    ],
                    "measures": 0
                }
            ]
        },
        "tracks": [
            {
                "channel": 1,
                "controlChanges": {
                    "7": [
                        {
                            "number": 7,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.6299212598425197
                        }
                    ]
                },
                "pitchBends": [],
                "instrument": {
                    "family": "organ",
                    "number": 17,
                    "name": "percussive_organ"
                },
                "name": "R.H.                ",
                "notes": [
                    {
                        "duration": 0.6666666666666666,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 0,
                        "time": 0,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666666,
                        "durationTicks": 128,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 0,
                        "time": 0,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666663,
                        "durationTicks": 32,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 144,
                        "time": 0.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666663,
                        "durationTicks": 32,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 144,
                        "time": 0.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666667,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 192,
                        "time": 1,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666667,
                        "durationTicks": 176,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 192,
                        "time": 1,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666665,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 384,
                        "time": 2,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666665,
                        "durationTicks": 176,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 384,
                        "time": 2,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666665,
                        "durationTicks": 128,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 576,
                        "time": 3,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666665,
                        "durationTicks": 128,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 576,
                        "time": 3,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666652,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 720,
                        "time": 3.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.416666666666667,
                        "durationTicks": 272,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 768,
                        "time": 4,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.416666666666667,
                        "durationTicks": 272,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 768,
                        "time": 4,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.666666666666667,
                        "durationTicks": 128,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 1152,
                        "time": 6,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.666666666666667,
                        "durationTicks": 128,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 1152,
                        "time": 6,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.666666666666667,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 1152,
                        "time": 6,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666696,
                        "durationTicks": 32,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 1296,
                        "time": 6.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666696,
                        "durationTicks": 32,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 1296,
                        "time": 6.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666696,
                        "durationTicks": 32,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 1296,
                        "time": 6.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.916666666666667,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 1344,
                        "time": 7,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.916666666666667,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 1344,
                        "time": 7,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.916666666666667,
                        "durationTicks": 176,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 1344,
                        "time": 7,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 1536,
                        "time": 8,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 1536,
                        "time": 8,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666661,
                        "durationTicks": 128,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 1728,
                        "time": 9,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666661,
                        "durationTicks": 128,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 1728,
                        "time": 9,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666607,
                        "durationTicks": 32,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 1872,
                        "time": 9.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666607,
                        "durationTicks": 32,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 1872,
                        "time": 9.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 1920,
                        "time": 10,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 1920,
                        "time": 10,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.416666666666666,
                        "durationTicks": 272,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 2304,
                        "time": 12,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.416666666666666,
                        "durationTicks": 272,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 2304,
                        "time": 12,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 2592,
                        "time": 13.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 2592,
                        "time": 13.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 2688,
                        "time": 14,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 2688,
                        "time": 14,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 2784,
                        "time": 14.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 2784,
                        "time": 14.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666679,
                        "durationTicks": 272,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 2880,
                        "time": 15,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 64,
                        "name": "E4",
                        "ticks": 2880,
                        "time": 15,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 3168,
                        "time": 16.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 3264,
                        "time": 17,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 3264,
                        "time": 17,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 3264,
                        "time": 17,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 3456,
                        "time": 18,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 3456,
                        "time": 18,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 3840,
                        "time": 20,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 64,
                        "name": "E4",
                        "ticks": 3840,
                        "time": 20,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 3936,
                        "time": 20.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.416666666666668,
                        "durationTicks": 464,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 4032,
                        "time": 21,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.416666666666668,
                        "durationTicks": 464,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 4032,
                        "time": 21,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666679,
                        "durationTicks": 128,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4608,
                        "time": 24,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666679,
                        "durationTicks": 128,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 4608,
                        "time": 24,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666785,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4752,
                        "time": 24.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666785,
                        "durationTicks": 32,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 4752,
                        "time": 24.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 4800,
                        "time": 25,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4800,
                        "time": 25,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4992,
                        "time": 26,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 4992,
                        "time": 26,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666679,
                        "durationTicks": 272,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 5184,
                        "time": 27,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 5184,
                        "time": 27,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 5472,
                        "time": 28.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 5568,
                        "time": 29,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 5568,
                        "time": 29,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 5568,
                        "time": 29,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 5664,
                        "time": 29.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 5664,
                        "time": 29.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 5760,
                        "time": 30,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666679,
                        "durationTicks": 272,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 5760,
                        "time": 30,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666679,
                        "durationTicks": 272,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 5760,
                        "time": 30,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 5952,
                        "time": 31,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 6144,
                        "time": 32,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 6144,
                        "time": 32,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 6336,
                        "time": 33,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 6336,
                        "time": 33,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 6336,
                        "time": 33,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 6912,
                        "time": 36,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 6912,
                        "time": 36,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 7056,
                        "time": 36.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 7056,
                        "time": 36.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 7104,
                        "time": 37,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 7104,
                        "time": 37,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 7296,
                        "time": 38,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 7296,
                        "time": 38,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 7488,
                        "time": 39,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666643,
                        "durationTicks": 368,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 7488,
                        "time": 39,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 7776,
                        "time": 40.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 7872,
                        "time": 41,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 7872,
                        "time": 41,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666643,
                        "durationTicks": 368,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 8064,
                        "time": 42,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 8064,
                        "time": 42,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 8256,
                        "time": 43,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 8448,
                        "time": 44,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 8448,
                        "time": 44,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 8640,
                        "time": 45,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 8640,
                        "time": 45,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 9216,
                        "time": 48,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 9216,
                        "time": 48,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 9360,
                        "time": 48.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 9360,
                        "time": 48.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 9408,
                        "time": 49,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 9408,
                        "time": 49,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 9600,
                        "time": 50,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 9600,
                        "time": 50,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 9792,
                        "time": 51,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 9792,
                        "time": 51,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 9792,
                        "time": 51,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 9936,
                        "time": 51.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 9936,
                        "time": 51.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 9936,
                        "time": 51.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 9984,
                        "time": 52,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 9984,
                        "time": 52,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 9984,
                        "time": 52,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 10368,
                        "time": 54,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 10368,
                        "time": 54,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 10368,
                        "time": 54,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 10512,
                        "time": 54.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 10512,
                        "time": 54.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 10512,
                        "time": 54.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 10560,
                        "time": 55,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 10560,
                        "time": 55,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 10560,
                        "time": 55,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 10752,
                        "time": 56,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 10752,
                        "time": 56,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 10752,
                        "time": 56,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 10944,
                        "time": 57,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 10944,
                        "time": 57,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 10944,
                        "time": 57,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 11088,
                        "time": 57.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 11088,
                        "time": 57.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 11088,
                        "time": 57.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 11136,
                        "time": 58,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 11136,
                        "time": 58,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 11136,
                        "time": 58,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 11520,
                        "time": 60,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 11520,
                        "time": 60,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 66,
                        "name": "F#4",
                        "ticks": 11808,
                        "time": 61.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 11808,
                        "time": 61.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 75,
                        "name": "D#5",
                        "ticks": 11904,
                        "time": 62,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 11904,
                        "time": 62,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 12000,
                        "time": 62.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 12000,
                        "time": 62.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 12096,
                        "time": 63,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 12096,
                        "time": 63,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 12480,
                        "time": 65,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 12480,
                        "time": 65,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 12480,
                        "time": 65,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 12672,
                        "time": 66,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 12672,
                        "time": 66,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 12672,
                        "time": 66,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 13056,
                        "time": 68,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 13056,
                        "time": 68,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 13056,
                        "time": 68,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666714,
                        "durationTicks": 272,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 13248,
                        "time": 69,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666714,
                        "durationTicks": 272,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 13248,
                        "time": 69,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666714,
                        "durationTicks": 272,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 13248,
                        "time": 69,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 66,
                        "name": "F#4",
                        "ticks": 13536,
                        "time": 70.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 13536,
                        "time": 70.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 13536,
                        "time": 70.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 75,
                        "name": "D#5",
                        "ticks": 13632,
                        "time": 71,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 13632,
                        "time": 71,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 13728,
                        "time": 71.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 13728,
                        "time": 71.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 13728,
                        "time": 71.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 13824,
                        "time": 72,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 13824,
                        "time": 72,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 13824,
                        "time": 72,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 61,
                        "name": "C#4",
                        "ticks": 14208,
                        "time": 74,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 14208,
                        "time": 74,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 14208,
                        "time": 74,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 14400,
                        "time": 75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 14400,
                        "time": 75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 14400,
                        "time": 75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 14592,
                        "time": 76,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 14688,
                        "time": 76.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 14784,
                        "time": 77,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 14784,
                        "time": 77,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 14784,
                        "time": 77,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.9166666666666714,
                        "durationTicks": 560,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 14976,
                        "time": 78,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.9166666666666714,
                        "durationTicks": 560,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 14976,
                        "time": 78,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.9166666666666714,
                        "durationTicks": 560,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 14976,
                        "time": 78,
                        "velocity": 0.7874015748031497
                    }
                ],
                "endOfTrackTicks": 15536
            },
            {
                "channel": 2,
                "controlChanges": {
                    "7": [
                        {
                            "number": 7,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.6299212598425197
                        }
                    ]
                },
                "pitchBends": [],
                "instrument": {
                    "family": "organ",
                    "number": 18,
                    "name": "rock_organ"
                },
                "name": "L.H.                ",
                "notes": [
                    {
                        "duration": 0.6666666666666666,
                        "durationTicks": 128,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 0,
                        "time": 0,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666666,
                        "durationTicks": 128,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 0,
                        "time": 0,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666663,
                        "durationTicks": 32,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 144,
                        "time": 0.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666663,
                        "durationTicks": 32,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 144,
                        "time": 0.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666667,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 192,
                        "time": 1,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666667,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 192,
                        "time": 1,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666665,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 384,
                        "time": 2,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666665,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 384,
                        "time": 2,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666665,
                        "durationTicks": 128,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 576,
                        "time": 3,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666665,
                        "durationTicks": 128,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 576,
                        "time": 3,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666652,
                        "durationTicks": 32,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 720,
                        "time": 3.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666652,
                        "durationTicks": 32,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 720,
                        "time": 3.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.416666666666667,
                        "durationTicks": 272,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 768,
                        "time": 4,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.416666666666667,
                        "durationTicks": 272,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 768,
                        "time": 4,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.666666666666667,
                        "durationTicks": 128,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 1152,
                        "time": 6,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666696,
                        "durationTicks": 32,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 1296,
                        "time": 6.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.916666666666667,
                        "durationTicks": 176,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 1344,
                        "time": 7,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 1536,
                        "time": 8,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 1536,
                        "time": 8,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666661,
                        "durationTicks": 128,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 1728,
                        "time": 9,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666661,
                        "durationTicks": 128,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 1728,
                        "time": 9,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666607,
                        "durationTicks": 32,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 1872,
                        "time": 9.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666607,
                        "durationTicks": 32,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 1872,
                        "time": 9.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 1920,
                        "time": 10,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 1920,
                        "time": 10,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 2304,
                        "time": 12,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 2304,
                        "time": 12,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 2496,
                        "time": 13,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 2496,
                        "time": 13,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 2688,
                        "time": 14,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 2688,
                        "time": 14,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 2880,
                        "time": 15,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 43,
                        "name": "G2",
                        "ticks": 2880,
                        "time": 15,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 3072,
                        "time": 16,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 3264,
                        "time": 17,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 3264,
                        "time": 17,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 3456,
                        "time": 18,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 3456,
                        "time": 18,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 3648,
                        "time": 19,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 3840,
                        "time": 20,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.416666666666668,
                        "durationTicks": 464,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 4032,
                        "time": 21,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.416666666666668,
                        "durationTicks": 464,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 4032,
                        "time": 21,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 4608,
                        "time": 24,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 4800,
                        "time": 25,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 4992,
                        "time": 26,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 5184,
                        "time": 27,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 5376,
                        "time": 28,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 5568,
                        "time": 29,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 5760,
                        "time": 30,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 6144,
                        "time": 32,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 6336,
                        "time": 33,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 6912,
                        "time": 36,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 7104,
                        "time": 37,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 7296,
                        "time": 38,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 7296,
                        "time": 38,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 7488,
                        "time": 39,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 7488,
                        "time": 39,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 7776,
                        "time": 40.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 7776,
                        "time": 40.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 7872,
                        "time": 41,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 7872,
                        "time": 41,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.9166666666666643,
                        "durationTicks": 560,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 8064,
                        "time": 42,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666643,
                        "durationTicks": 368,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 8064,
                        "time": 42,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8448,
                        "time": 44,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 8640,
                        "time": 45,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 8640,
                        "time": 45,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9216,
                        "time": 48,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 9216,
                        "time": 48,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9360,
                        "time": 48.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 9360,
                        "time": 48.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9408,
                        "time": 49,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 9408,
                        "time": 49,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 9600,
                        "time": 50,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 9792,
                        "time": 51,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 9936,
                        "time": 51.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 9984,
                        "time": 52,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 10368,
                        "time": 54,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 10512,
                        "time": 54.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 10560,
                        "time": 55,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 10752,
                        "time": 56,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 10944,
                        "time": 57,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 11088,
                        "time": 57.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 11136,
                        "time": 58,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666643,
                        "durationTicks": 368,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11520,
                        "time": 60,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 11520,
                        "time": 60,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 11712,
                        "time": 61,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 11904,
                        "time": 62,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 11904,
                        "time": 62,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 12000,
                        "time": 62.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 12096,
                        "time": 63,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 54,
                        "name": "F#3",
                        "ticks": 12480,
                        "time": 65,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 12672,
                        "time": 66,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 13056,
                        "time": 68,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 13248,
                        "time": 69,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 13440,
                        "time": 70,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 39,
                        "name": "D#2",
                        "ticks": 13632,
                        "time": 71,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 13632,
                        "time": 71,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 13824,
                        "time": 72,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 13824,
                        "time": 72,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 14208,
                        "time": 74,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 14208,
                        "time": 74,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 14400,
                        "time": 75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 14400,
                        "time": 75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 14784,
                        "time": 77,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 14784,
                        "time": 77,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.9166666666666714,
                        "durationTicks": 560,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 14976,
                        "time": 78,
                        "velocity": 0.7874015748031497
                    }
                ],
                "endOfTrackTicks": 15536
            },
            {
                "channel": 3,
                "controlChanges": {
                    "7": [
                        {
                            "number": 7,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.6299212598425197
                        }
                    ]
                },
                "pitchBends": [],
                "instrument": {
                    "family": "bass",
                    "number": 33,
                    "name": "electric_bass_finger"
                },
                "name": "BASS                ",
                "notes": [
                    {
                        "duration": 0.6666666666666666,
                        "durationTicks": 128,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 0,
                        "time": 0,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.16666666666666663,
                        "durationTicks": 32,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 144,
                        "time": 0.75,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666667,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 192,
                        "time": 1,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666665,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 384,
                        "time": 2,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.6666666666666665,
                        "durationTicks": 128,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 576,
                        "time": 3,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.16666666666666652,
                        "durationTicks": 32,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 720,
                        "time": 3.75,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 1.416666666666667,
                        "durationTicks": 272,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 768,
                        "time": 4,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.666666666666667,
                        "durationTicks": 128,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 1152,
                        "time": 6,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.16666666666666696,
                        "durationTicks": 32,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 1296,
                        "time": 6.75,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.916666666666667,
                        "durationTicks": 176,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 1344,
                        "time": 7,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 1536,
                        "time": 8,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.6666666666666661,
                        "durationTicks": 128,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 1728,
                        "time": 9,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.16666666666666607,
                        "durationTicks": 32,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 1872,
                        "time": 9.75,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 1920,
                        "time": 10,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 2304,
                        "time": 12,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 2496,
                        "time": 13,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 2688,
                        "time": 14,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 43,
                        "name": "G2",
                        "ticks": 2880,
                        "time": 15,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 3072,
                        "time": 16,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 3264,
                        "time": 17,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 3456,
                        "time": 18,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 3648,
                        "time": 19,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 3840,
                        "time": 20,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 2.416666666666668,
                        "durationTicks": 464,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 4032,
                        "time": 21,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 4608,
                        "time": 24,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 4800,
                        "time": 25,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 4992,
                        "time": 26,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 5184,
                        "time": 27,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 5376,
                        "time": 28,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 5568,
                        "time": 29,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 5760,
                        "time": 30,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 6144,
                        "time": 32,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 6336,
                        "time": 33,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 6912,
                        "time": 36,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 7104,
                        "time": 37,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 7296,
                        "time": 38,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 7488,
                        "time": 39,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 7776,
                        "time": 40.5,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 7872,
                        "time": 41,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 1.9166666666666643,
                        "durationTicks": 368,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 8064,
                        "time": 42,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8448,
                        "time": 44,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 8640,
                        "time": 45,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9216,
                        "time": 48,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9360,
                        "time": 48.75,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9408,
                        "time": 49,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 9600,
                        "time": 50,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 9792,
                        "time": 51,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 9936,
                        "time": 51.75,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 9984,
                        "time": 52,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 10368,
                        "time": 54,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 10512,
                        "time": 54.75,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 10560,
                        "time": 55,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 10752,
                        "time": 56,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 10944,
                        "time": 57,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 11088,
                        "time": 57.75,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 11136,
                        "time": 58,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11520,
                        "time": 60,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11712,
                        "time": 61,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 11904,
                        "time": 62,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 12096,
                        "time": 63,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 42,
                        "name": "F#2",
                        "ticks": 12480,
                        "time": 65,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 43,
                        "name": "G2",
                        "ticks": 12672,
                        "time": 66,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 13056,
                        "time": 68,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 13248,
                        "time": 69,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 13440,
                        "time": 70,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 39,
                        "name": "D#2",
                        "ticks": 13632,
                        "time": 71,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 13824,
                        "time": 72,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 14208,
                        "time": 74,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 14400,
                        "time": 75,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 14784,
                        "time": 77,
                        "velocity": 0.9448818897637795
                    },
                    {
                        "duration": 2.9166666666666714,
                        "durationTicks": 560,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 14976,
                        "time": 78,
                        "velocity": 0.9448818897637795
                    }
                ],
                "endOfTrackTicks": 15536
            },
            {
                "channel": 0,
                "controlChanges": {
                    "7": [
                        {
                            "number": 7,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.6299212598425197
                        }
                    ]
                },
                "pitchBends": [],
                "instrument": {
                    "family": "brass",
                    "number": 60,
                    "name": "french_horn"
                },
                "name": "MELODY              ",
                "notes": [
                    {
                        "duration": 0.6666666666666666,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 0,
                        "time": 0,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666663,
                        "durationTicks": 32,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 144,
                        "time": 0.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666667,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 192,
                        "time": 1,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666665,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 384,
                        "time": 2,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666665,
                        "durationTicks": 128,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 576,
                        "time": 3,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666652,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 720,
                        "time": 3.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.416666666666667,
                        "durationTicks": 272,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 768,
                        "time": 4,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.666666666666667,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 1152,
                        "time": 6,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666696,
                        "durationTicks": 32,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 1296,
                        "time": 6.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.916666666666667,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 1344,
                        "time": 7,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 1536,
                        "time": 8,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666661,
                        "durationTicks": 128,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 1728,
                        "time": 9,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666607,
                        "durationTicks": 32,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 1872,
                        "time": 9.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 1920,
                        "time": 10,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.416666666666666,
                        "durationTicks": 272,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 2304,
                        "time": 12,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 2592,
                        "time": 13.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 2688,
                        "time": 14,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 2784,
                        "time": 14.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666679,
                        "durationTicks": 272,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 2880,
                        "time": 15,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 3168,
                        "time": 16.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 3264,
                        "time": 17,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 3456,
                        "time": 18,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 64,
                        "name": "E4",
                        "ticks": 3840,
                        "time": 20,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.416666666666668,
                        "durationTicks": 464,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 4032,
                        "time": 21,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666679,
                        "durationTicks": 128,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4608,
                        "time": 24,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666785,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4752,
                        "time": 24.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4800,
                        "time": 25,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4992,
                        "time": 26,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666679,
                        "durationTicks": 272,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 5184,
                        "time": 27,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 5472,
                        "time": 28.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 5568,
                        "time": 29,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 5664,
                        "time": 29.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.9166666666666643,
                        "durationTicks": 560,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 5760,
                        "time": 30,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 6336,
                        "time": 33,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 6912,
                        "time": 36,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 7056,
                        "time": 36.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 7104,
                        "time": 37,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 7296,
                        "time": 38,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 7488,
                        "time": 39,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 7776,
                        "time": 40.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 7872,
                        "time": 41,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666643,
                        "durationTicks": 368,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 8064,
                        "time": 42,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 8448,
                        "time": 44,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 8640,
                        "time": 45,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 9216,
                        "time": 48,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 9360,
                        "time": 48.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 9408,
                        "time": 49,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 9600,
                        "time": 50,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 9792,
                        "time": 51,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 9936,
                        "time": 51.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 9984,
                        "time": 52,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 10368,
                        "time": 54,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 10512,
                        "time": 54.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 10560,
                        "time": 55,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 10752,
                        "time": 56,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 10944,
                        "time": 57,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 11088,
                        "time": 57.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 11136,
                        "time": 58,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 11520,
                        "time": 60,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 11808,
                        "time": 61.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 75,
                        "name": "D#5",
                        "ticks": 11904,
                        "time": 62,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 12000,
                        "time": 62.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 12096,
                        "time": 63,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 12480,
                        "time": 65,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 12672,
                        "time": 66,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 13056,
                        "time": 68,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 13248,
                        "time": 69,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 13536,
                        "time": 70.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 75,
                        "name": "D#5",
                        "ticks": 13632,
                        "time": 71,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 13728,
                        "time": 71.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 13824,
                        "time": 72,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 14208,
                        "time": 74,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 14400,
                        "time": 75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 14592,
                        "time": 76,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 14688,
                        "time": 76.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 14784,
                        "time": 77,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.9166666666666714,
                        "durationTicks": 560,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 14976,
                        "time": 78,
                        "velocity": 0.7874015748031497
                    }
                ],
                "endOfTrackTicks": 15536
            },
            {
                "channel": 4,
                "controlChanges": {
                    "7": [
                        {
                            "number": 7,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.6299212598425197
                        }
                    ]
                },
                "pitchBends": [],
                "instrument": {
                    "family": "pipe",
                    "number": 78,
                    "name": "whistle"
                },
                "name": "layer               ",
                "notes": [
                    {
                        "duration": 0.6666666666666666,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 0,
                        "time": 0,
                        "velocity": 1
                    },
                    {
                        "duration": 0.16666666666666663,
                        "durationTicks": 32,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 144,
                        "time": 0.75,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666667,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 192,
                        "time": 1,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666665,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 384,
                        "time": 2,
                        "velocity": 1
                    },
                    {
                        "duration": 0.6666666666666665,
                        "durationTicks": 128,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 576,
                        "time": 3,
                        "velocity": 1
                    },
                    {
                        "duration": 0.16666666666666652,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 720,
                        "time": 3.75,
                        "velocity": 1
                    },
                    {
                        "duration": 1.416666666666667,
                        "durationTicks": 272,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 768,
                        "time": 4,
                        "velocity": 1
                    },
                    {
                        "duration": 0.666666666666667,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 1152,
                        "time": 6,
                        "velocity": 1
                    },
                    {
                        "duration": 0.16666666666666696,
                        "durationTicks": 32,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 1296,
                        "time": 6.75,
                        "velocity": 1
                    },
                    {
                        "duration": 0.916666666666667,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 1344,
                        "time": 7,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 1536,
                        "time": 8,
                        "velocity": 1
                    },
                    {
                        "duration": 0.6666666666666661,
                        "durationTicks": 128,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 1728,
                        "time": 9,
                        "velocity": 1
                    },
                    {
                        "duration": 0.16666666666666607,
                        "durationTicks": 32,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 1872,
                        "time": 9.75,
                        "velocity": 1
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 1920,
                        "time": 10,
                        "velocity": 1
                    },
                    {
                        "duration": 1.416666666666666,
                        "durationTicks": 272,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 2304,
                        "time": 12,
                        "velocity": 1
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 2592,
                        "time": 13.5,
                        "velocity": 1
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 2688,
                        "time": 14,
                        "velocity": 1
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 2784,
                        "time": 14.5,
                        "velocity": 1
                    },
                    {
                        "duration": 1.4166666666666679,
                        "durationTicks": 272,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 2880,
                        "time": 15,
                        "velocity": 1
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 3168,
                        "time": 16.5,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 3264,
                        "time": 17,
                        "velocity": 1
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 3456,
                        "time": 18,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 64,
                        "name": "E4",
                        "ticks": 3840,
                        "time": 20,
                        "velocity": 1
                    },
                    {
                        "duration": 2.416666666666668,
                        "durationTicks": 464,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 4032,
                        "time": 21,
                        "velocity": 1
                    },
                    {
                        "duration": 0.6666666666666679,
                        "durationTicks": 128,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4608,
                        "time": 24,
                        "velocity": 1
                    },
                    {
                        "duration": 0.16666666666666785,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4752,
                        "time": 24.75,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4800,
                        "time": 25,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4992,
                        "time": 26,
                        "velocity": 1
                    },
                    {
                        "duration": 1.4166666666666679,
                        "durationTicks": 272,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 5184,
                        "time": 27,
                        "velocity": 1
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 5472,
                        "time": 28.5,
                        "velocity": 1
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 5568,
                        "time": 29,
                        "velocity": 1
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 5664,
                        "time": 29.5,
                        "velocity": 1
                    },
                    {
                        "duration": 2.9166666666666643,
                        "durationTicks": 560,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 5760,
                        "time": 30,
                        "velocity": 1
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 6336,
                        "time": 33,
                        "velocity": 1
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 6912,
                        "time": 36,
                        "velocity": 1
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 7056,
                        "time": 36.75,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 7104,
                        "time": 37,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 7296,
                        "time": 38,
                        "velocity": 1
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 7488,
                        "time": 39,
                        "velocity": 1
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 7776,
                        "time": 40.5,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 7872,
                        "time": 41,
                        "velocity": 1
                    },
                    {
                        "duration": 1.9166666666666643,
                        "durationTicks": 368,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 8064,
                        "time": 42,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 8448,
                        "time": 44,
                        "velocity": 1
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 8640,
                        "time": 45,
                        "velocity": 1
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 9216,
                        "time": 48,
                        "velocity": 1
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 9360,
                        "time": 48.75,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 9408,
                        "time": 49,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 9600,
                        "time": 50,
                        "velocity": 1
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 9792,
                        "time": 51,
                        "velocity": 1
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 9936,
                        "time": 51.75,
                        "velocity": 1
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 9984,
                        "time": 52,
                        "velocity": 1
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 10368,
                        "time": 54,
                        "velocity": 1
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 10512,
                        "time": 54.75,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 10560,
                        "time": 55,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 10752,
                        "time": 56,
                        "velocity": 1
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 10944,
                        "time": 57,
                        "velocity": 1
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 11088,
                        "time": 57.75,
                        "velocity": 1
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 11136,
                        "time": 58,
                        "velocity": 1
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 11520,
                        "time": 60,
                        "velocity": 1
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 11808,
                        "time": 61.5,
                        "velocity": 1
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 75,
                        "name": "D#5",
                        "ticks": 11904,
                        "time": 62,
                        "velocity": 1
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 12000,
                        "time": 62.5,
                        "velocity": 1
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 12096,
                        "time": 63,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 12480,
                        "time": 65,
                        "velocity": 1
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 12672,
                        "time": 66,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 13056,
                        "time": 68,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 13248,
                        "time": 69,
                        "velocity": 1
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 13536,
                        "time": 70.5,
                        "velocity": 1
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 75,
                        "name": "D#5",
                        "ticks": 13632,
                        "time": 71,
                        "velocity": 1
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 13728,
                        "time": 71.5,
                        "velocity": 1
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 13824,
                        "time": 72,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 14208,
                        "time": 74,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 14400,
                        "time": 75,
                        "velocity": 1
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 14592,
                        "time": 76,
                        "velocity": 1
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 14688,
                        "time": 76.5,
                        "velocity": 1
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 14784,
                        "time": 77,
                        "velocity": 1
                    },
                    {
                        "duration": 2.9166666666666714,
                        "durationTicks": 560,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 14976,
                        "time": 78,
                        "velocity": 1
                    }
                ],
                "endOfTrackTicks": 15536
            },
            {
                "channel": 12,
                "controlChanges": {
                    "7": [
                        {
                            "number": 7,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.6299212598425197
                        }
                    ]
                },
                "pitchBends": [],
                "instrument": {
                    "family": "organ",
                    "number": 18,
                    "name": "rock_organ"
                },
                "name": "New Track           ",
                "notes": [
                    {
                        "duration": 0.6666666666666666,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 0,
                        "time": 0,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666666,
                        "durationTicks": 128,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 0,
                        "time": 0,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666663,
                        "durationTicks": 32,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 144,
                        "time": 0.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666663,
                        "durationTicks": 32,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 144,
                        "time": 0.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666667,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 192,
                        "time": 1,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666667,
                        "durationTicks": 176,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 192,
                        "time": 1,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666665,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 384,
                        "time": 2,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666665,
                        "durationTicks": 176,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 384,
                        "time": 2,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666665,
                        "durationTicks": 128,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 576,
                        "time": 3,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666665,
                        "durationTicks": 128,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 576,
                        "time": 3,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666652,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 720,
                        "time": 3.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.416666666666667,
                        "durationTicks": 272,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 768,
                        "time": 4,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.416666666666667,
                        "durationTicks": 272,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 768,
                        "time": 4,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.666666666666667,
                        "durationTicks": 128,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 1152,
                        "time": 6,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.666666666666667,
                        "durationTicks": 128,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 1152,
                        "time": 6,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.666666666666667,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 1152,
                        "time": 6,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666696,
                        "durationTicks": 32,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 1296,
                        "time": 6.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666696,
                        "durationTicks": 32,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 1296,
                        "time": 6.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666696,
                        "durationTicks": 32,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 1296,
                        "time": 6.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.916666666666667,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 1344,
                        "time": 7,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.916666666666667,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 1344,
                        "time": 7,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.916666666666667,
                        "durationTicks": 176,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 1344,
                        "time": 7,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 1536,
                        "time": 8,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 1536,
                        "time": 8,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666661,
                        "durationTicks": 128,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 1728,
                        "time": 9,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666661,
                        "durationTicks": 128,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 1728,
                        "time": 9,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666607,
                        "durationTicks": 32,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 1872,
                        "time": 9.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666607,
                        "durationTicks": 32,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 1872,
                        "time": 9.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 1920,
                        "time": 10,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 1920,
                        "time": 10,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.416666666666666,
                        "durationTicks": 272,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 2304,
                        "time": 12,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.416666666666666,
                        "durationTicks": 272,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 2304,
                        "time": 12,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 2592,
                        "time": 13.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 2592,
                        "time": 13.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 2688,
                        "time": 14,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 2688,
                        "time": 14,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 2784,
                        "time": 14.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666661,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 2784,
                        "time": 14.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666679,
                        "durationTicks": 272,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 2880,
                        "time": 15,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 64,
                        "name": "E4",
                        "ticks": 2880,
                        "time": 15,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 3168,
                        "time": 16.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 3264,
                        "time": 17,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 3264,
                        "time": 17,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 3264,
                        "time": 17,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 3456,
                        "time": 18,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 3456,
                        "time": 18,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 3840,
                        "time": 20,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 64,
                        "name": "E4",
                        "ticks": 3840,
                        "time": 20,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 3936,
                        "time": 20.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.416666666666668,
                        "durationTicks": 464,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 4032,
                        "time": 21,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.416666666666668,
                        "durationTicks": 464,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 4032,
                        "time": 21,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666679,
                        "durationTicks": 128,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4608,
                        "time": 24,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666679,
                        "durationTicks": 128,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 4608,
                        "time": 24,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666785,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4752,
                        "time": 24.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666785,
                        "durationTicks": 32,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 4752,
                        "time": 24.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 4800,
                        "time": 25,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4800,
                        "time": 25,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4992,
                        "time": 26,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 4992,
                        "time": 26,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666679,
                        "durationTicks": 272,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 5184,
                        "time": 27,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 5184,
                        "time": 27,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 5472,
                        "time": 28.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 5568,
                        "time": 29,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 5568,
                        "time": 29,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 5568,
                        "time": 29,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 5664,
                        "time": 29.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 5664,
                        "time": 29.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 5760,
                        "time": 30,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666679,
                        "durationTicks": 272,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 5760,
                        "time": 30,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666679,
                        "durationTicks": 272,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 5760,
                        "time": 30,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 5952,
                        "time": 31,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 6144,
                        "time": 32,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 6144,
                        "time": 32,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 6336,
                        "time": 33,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 6336,
                        "time": 33,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 6336,
                        "time": 33,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 6912,
                        "time": 36,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 6912,
                        "time": 36,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 7056,
                        "time": 36.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 7056,
                        "time": 36.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 7104,
                        "time": 37,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 7104,
                        "time": 37,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 7296,
                        "time": 38,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 7296,
                        "time": 38,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 7488,
                        "time": 39,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666643,
                        "durationTicks": 368,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 7488,
                        "time": 39,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 7776,
                        "time": 40.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 7872,
                        "time": 41,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 7872,
                        "time": 41,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666643,
                        "durationTicks": 368,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 8064,
                        "time": 42,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 8064,
                        "time": 42,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 8256,
                        "time": 43,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 8448,
                        "time": 44,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 8448,
                        "time": 44,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 8640,
                        "time": 45,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 8640,
                        "time": 45,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 9216,
                        "time": 48,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 9216,
                        "time": 48,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 9360,
                        "time": 48.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 9360,
                        "time": 48.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 9408,
                        "time": 49,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 9408,
                        "time": 49,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 9600,
                        "time": 50,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 9600,
                        "time": 50,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 9792,
                        "time": 51,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 9792,
                        "time": 51,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 9792,
                        "time": 51,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 9936,
                        "time": 51.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 9936,
                        "time": 51.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 9936,
                        "time": 51.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 9984,
                        "time": 52,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 9984,
                        "time": 52,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 9984,
                        "time": 52,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 10368,
                        "time": 54,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 10368,
                        "time": 54,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 10368,
                        "time": 54,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 10512,
                        "time": 54.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 10512,
                        "time": 54.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 10512,
                        "time": 54.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 10560,
                        "time": 55,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 10560,
                        "time": 55,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 10560,
                        "time": 55,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 10752,
                        "time": 56,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 10752,
                        "time": 56,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 10752,
                        "time": 56,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 10944,
                        "time": 57,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 10944,
                        "time": 57,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 10944,
                        "time": 57,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 11088,
                        "time": 57.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 11088,
                        "time": 57.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 11088,
                        "time": 57.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 11136,
                        "time": 58,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 11136,
                        "time": 58,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 11136,
                        "time": 58,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 11520,
                        "time": 60,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 11520,
                        "time": 60,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 66,
                        "name": "F#4",
                        "ticks": 11808,
                        "time": 61.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 11808,
                        "time": 61.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 75,
                        "name": "D#5",
                        "ticks": 11904,
                        "time": 62,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 11904,
                        "time": 62,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 12000,
                        "time": 62.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 12000,
                        "time": 62.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 12096,
                        "time": 63,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 12096,
                        "time": 63,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 12480,
                        "time": 65,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 12480,
                        "time": 65,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 12480,
                        "time": 65,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 12672,
                        "time": 66,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 12672,
                        "time": 66,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 12672,
                        "time": 66,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 13056,
                        "time": 68,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 13056,
                        "time": 68,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 13056,
                        "time": 68,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666714,
                        "durationTicks": 272,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 13248,
                        "time": 69,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666714,
                        "durationTicks": 272,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 13248,
                        "time": 69,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666714,
                        "durationTicks": 272,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 13248,
                        "time": 69,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 66,
                        "name": "F#4",
                        "ticks": 13536,
                        "time": 70.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 13536,
                        "time": 70.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 13536,
                        "time": 70.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 75,
                        "name": "D#5",
                        "ticks": 13632,
                        "time": 71,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 13632,
                        "time": 71,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 13728,
                        "time": 71.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 13728,
                        "time": 71.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 13728,
                        "time": 71.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 13824,
                        "time": 72,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 13824,
                        "time": 72,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 13824,
                        "time": 72,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 61,
                        "name": "C#4",
                        "ticks": 14208,
                        "time": 74,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 14208,
                        "time": 74,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 14208,
                        "time": 74,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 14400,
                        "time": 75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 14400,
                        "time": 75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 14400,
                        "time": 75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 14592,
                        "time": 76,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666714,
                        "durationTicks": 80,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 14688,
                        "time": 76.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 63,
                        "name": "D#4",
                        "ticks": 14784,
                        "time": 77,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 14784,
                        "time": 77,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 14784,
                        "time": 77,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.9166666666666714,
                        "durationTicks": 560,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 14976,
                        "time": 78,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.9166666666666714,
                        "durationTicks": 560,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 14976,
                        "time": 78,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.9166666666666714,
                        "durationTicks": 560,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 14976,
                        "time": 78,
                        "velocity": 0.7874015748031497
                    }
                ],
                "endOfTrackTicks": 15536
            },
            {
                "channel": 13,
                "controlChanges": {
                    "7": [
                        {
                            "number": 7,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.6299212598425197
                        }
                    ]
                },
                "pitchBends": [],
                "instrument": {
                    "family": "organ",
                    "number": 20,
                    "name": "reed_organ"
                },
                "name": "New Track           ",
                "notes": [
                    {
                        "duration": 0.6666666666666666,
                        "durationTicks": 128,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 0,
                        "time": 0,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666666,
                        "durationTicks": 128,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 0,
                        "time": 0,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666663,
                        "durationTicks": 32,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 144,
                        "time": 0.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666663,
                        "durationTicks": 32,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 144,
                        "time": 0.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666667,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 192,
                        "time": 1,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666667,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 192,
                        "time": 1,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666665,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 384,
                        "time": 2,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666665,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 384,
                        "time": 2,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666665,
                        "durationTicks": 128,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 576,
                        "time": 3,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666665,
                        "durationTicks": 128,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 576,
                        "time": 3,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666652,
                        "durationTicks": 32,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 720,
                        "time": 3.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666652,
                        "durationTicks": 32,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 720,
                        "time": 3.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.416666666666667,
                        "durationTicks": 272,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 768,
                        "time": 4,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.416666666666667,
                        "durationTicks": 272,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 768,
                        "time": 4,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.666666666666667,
                        "durationTicks": 128,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 1152,
                        "time": 6,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666696,
                        "durationTicks": 32,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 1296,
                        "time": 6.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.916666666666667,
                        "durationTicks": 176,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 1344,
                        "time": 7,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 1536,
                        "time": 8,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 1536,
                        "time": 8,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666661,
                        "durationTicks": 128,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 1728,
                        "time": 9,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666661,
                        "durationTicks": 128,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 1728,
                        "time": 9,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.17708333333333393,
                        "durationTicks": 34,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 1872,
                        "time": 9.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.16666666666666607,
                        "durationTicks": 32,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 1872,
                        "time": 9.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 1920,
                        "time": 10,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 1920,
                        "time": 10,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 2304,
                        "time": 12,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 2304,
                        "time": 12,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 2496,
                        "time": 13,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 2496,
                        "time": 13,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 2688,
                        "time": 14,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 2688,
                        "time": 14,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 2880,
                        "time": 15,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666661,
                        "durationTicks": 176,
                        "midi": 43,
                        "name": "G2",
                        "ticks": 2880,
                        "time": 15,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 3072,
                        "time": 16,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 3264,
                        "time": 17,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 3264,
                        "time": 17,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 3456,
                        "time": 18,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 3456,
                        "time": 18,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 3648,
                        "time": 19,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.41666666666666785,
                        "durationTicks": 80,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 3840,
                        "time": 20,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.416666666666668,
                        "durationTicks": 464,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 4032,
                        "time": 21,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.416666666666668,
                        "durationTicks": 464,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 4032,
                        "time": 21,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 4608,
                        "time": 24,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 4800,
                        "time": 25,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 4992,
                        "time": 26,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 5184,
                        "time": 27,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 5376,
                        "time": 28,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666679,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 5568,
                        "time": 29,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666679,
                        "durationTicks": 368,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 5760,
                        "time": 30,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 6144,
                        "time": 32,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 6336,
                        "time": 33,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 6912,
                        "time": 36,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 7104,
                        "time": 37,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 7296,
                        "time": 38,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 7296,
                        "time": 38,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 7488,
                        "time": 39,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 7488,
                        "time": 39,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 7776,
                        "time": 40.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 7776,
                        "time": 40.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 7872,
                        "time": 41,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 7872,
                        "time": 41,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.9166666666666643,
                        "durationTicks": 560,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 8064,
                        "time": 42,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666643,
                        "durationTicks": 368,
                        "midi": 45,
                        "name": "A2",
                        "ticks": 8064,
                        "time": 42,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8448,
                        "time": 44,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 8640,
                        "time": 45,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2,
                        "durationTicks": 384,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 8640,
                        "time": 45,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9216,
                        "time": 48,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 9216,
                        "time": 48,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9360,
                        "time": 48.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 9360,
                        "time": 48.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9408,
                        "time": 49,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 9408,
                        "time": 49,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 9600,
                        "time": 50,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 9792,
                        "time": 51,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 9936,
                        "time": 51.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1,
                        "durationTicks": 192,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 9984,
                        "time": 52,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 10368,
                        "time": 54,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 10512,
                        "time": 54.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 10560,
                        "time": 55,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 10752,
                        "time": 56,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.6666666666666643,
                        "durationTicks": 128,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 10944,
                        "time": 57,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.1666666666666643,
                        "durationTicks": 32,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 11088,
                        "time": 57.75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.4166666666666643,
                        "durationTicks": 272,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 11136,
                        "time": 58,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666643,
                        "durationTicks": 368,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11520,
                        "time": 60,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 11520,
                        "time": 60,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 11712,
                        "time": 61,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666643,
                        "durationTicks": 176,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 11904,
                        "time": 62,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 11904,
                        "time": 62,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.4166666666666643,
                        "durationTicks": 80,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 12000,
                        "time": 62.5,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 12096,
                        "time": 63,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 54,
                        "name": "F#3",
                        "ticks": 12480,
                        "time": 65,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 12672,
                        "time": 66,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 13056,
                        "time": 68,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 13248,
                        "time": 69,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 13440,
                        "time": 70,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 39,
                        "name": "D#2",
                        "ticks": 13632,
                        "time": 71,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 13632,
                        "time": 71,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 13824,
                        "time": 72,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 13824,
                        "time": 72,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 14208,
                        "time": 74,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 14208,
                        "time": 74,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 14400,
                        "time": 75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 1.9166666666666714,
                        "durationTicks": 368,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 14400,
                        "time": 75,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 41,
                        "name": "F2",
                        "ticks": 14784,
                        "time": 77,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 0.9166666666666714,
                        "durationTicks": 176,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 14784,
                        "time": 77,
                        "velocity": 0.7874015748031497
                    },
                    {
                        "duration": 2.9166666666666714,
                        "durationTicks": 560,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 14976,
                        "time": 78,
                        "velocity": 0.7874015748031497
                    }
                ],
                "endOfTrackTicks": 15536
            }
        ]
    }
};
export const midilovania: Song = {
    name: "midilovania",
    midi: lovania,
    track: {
        "header": {
            "keySignatures": [
                {
                    "key": "F",
                    "scale": "minor",
                    "ticks": 0
                }
            ],
            "meta": [],
            "name": "Megalovania",
            "ppq": 96,
            "tempos": [
                {
                    "bpm": 229.99961666730556,
                    "ticks": 0
                }
            ],
            "timeSignatures": [
                {
                    "ticks": 0,
                    "timeSignature": [
                        4,
                        4
                    ],
                    "measures": 0
                }
            ]
        },
        "tracks": [
            {
                "channel": 0,
                "controlChanges": {},
                "pitchBends": [],
                "instrument": {
                    "family": "piano",
                    "number": 0,
                    "name": "acoustic_grand_piano"
                },
                "name": "",
                "notes": [],
                "endOfTrackTicks": 0
            },
            {
                "channel": 9,
                "controlChanges": {
                    "6": [
                        {
                            "number": 6,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.09448818897637795
                        }
                    ],
                    "7": [
                        {
                            "number": 7,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.8267716535433071
                        }
                    ],
                    "10": [
                        {
                            "number": 10,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.5039370078740157
                        }
                    ],
                    "64": [
                        {
                            "number": 64,
                            "ticks": 0,
                            "time": 0,
                            "value": 0
                        }
                    ],
                    "91": [
                        {
                            "number": 91,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.14960629921259844
                        }
                    ],
                    "100": [
                        {
                            "number": 100,
                            "ticks": 0,
                            "time": 0,
                            "value": 0
                        }
                    ],
                    "101": [
                        {
                            "number": 101,
                            "ticks": 0,
                            "time": 0,
                            "value": 0
                        }
                    ]
                },
                "pitchBends": [
                    {
                        "ticks": 0,
                        "time": 0,
                        "value": 0
                    }
                ],
                "instrument": {
                    "family": "drums",
                    "number": 0,
                    "name": "synth_drum"
                },
                "name": "",
                "notes": [
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 5760,
                        "time": 15.652199999999999,
                        "velocity": 0.2440944881889764
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 5856,
                        "time": 15.91307,
                        "velocity": 0.3779527559055118
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 5952,
                        "time": 16.173939999999998,
                        "velocity": 0.5118110236220472
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 6048,
                        "time": 16.43481,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 6144,
                        "time": 16.69568,
                        "velocity": 0.6614173228346457
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 6144,
                        "time": 16.69568,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 6144,
                        "time": 16.69568,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 6240,
                        "time": 16.95655,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 6240,
                        "time": 16.95655,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 6336,
                        "time": 17.21742,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 6336,
                        "time": 17.21742,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 6432,
                        "time": 17.478289999999998,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 6432,
                        "time": 17.478289999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 6480,
                        "time": 17.608725,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 6528,
                        "time": 17.73916,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 6576,
                        "time": 17.869595,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 6624,
                        "time": 18.00003,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 6624,
                        "time": 18.00003,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 6672,
                        "time": 18.130465,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 6720,
                        "time": 18.2609,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 6720,
                        "time": 18.2609,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 6816,
                        "time": 18.52177,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 6816,
                        "time": 18.52177,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 6816,
                        "time": 18.52177,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 6912,
                        "time": 18.78264,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 6912,
                        "time": 18.78264,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 7008,
                        "time": 19.043509999999998,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 7008,
                        "time": 19.043509999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 7104,
                        "time": 19.30438,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7104,
                        "time": 19.30438,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 7200,
                        "time": 19.56525,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 7200,
                        "time": 19.56525,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7248,
                        "time": 19.695685,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 7296,
                        "time": 19.82612,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7344,
                        "time": 19.956554999999998,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 7392,
                        "time": 20.08699,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 7392,
                        "time": 20.08699,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7440,
                        "time": 20.217425,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 7488,
                        "time": 20.34786,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7488,
                        "time": 20.34786,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 7584,
                        "time": 20.608729999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7584,
                        "time": 20.608729999999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 7584,
                        "time": 20.608729999999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 7680,
                        "time": 20.8696,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7680,
                        "time": 20.8696,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 7776,
                        "time": 21.13047,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 7776,
                        "time": 21.13047,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 7872,
                        "time": 21.39134,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7872,
                        "time": 21.39134,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 7968,
                        "time": 21.65221,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 7968,
                        "time": 21.65221,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 8016,
                        "time": 21.782645,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8064,
                        "time": 21.91308,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 8112,
                        "time": 22.043515,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8160,
                        "time": 22.173949999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 8160,
                        "time": 22.173949999999998,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 8208,
                        "time": 22.304385,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8256,
                        "time": 22.43482,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 8256,
                        "time": 22.43482,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8352,
                        "time": 22.69569,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 8352,
                        "time": 22.69569,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 8352,
                        "time": 22.69569,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8448,
                        "time": 22.95656,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 8448,
                        "time": 22.95656,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8544,
                        "time": 23.21743,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 8544,
                        "time": 23.21743,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8640,
                        "time": 23.4783,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 8640,
                        "time": 23.4783,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 8688,
                        "time": 23.608735,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8736,
                        "time": 23.739169999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 8784,
                        "time": 23.869605,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 8784,
                        "time": 23.869605,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8832,
                        "time": 24.00004,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 8880,
                        "time": 24.130475,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 8928,
                        "time": 24.26091,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8928,
                        "time": 24.26091,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 8976,
                        "time": 24.391344999999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9024,
                        "time": 24.52178,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 9024,
                        "time": 24.52178,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 9024,
                        "time": 24.52178,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 9120,
                        "time": 24.78265,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 9120,
                        "time": 24.78265,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9120,
                        "time": 24.78265,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 9216,
                        "time": 25.04352,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9216,
                        "time": 25.04352,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 9216,
                        "time": 25.04352,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 9312,
                        "time": 25.304389999999998,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9312,
                        "time": 25.304389999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9408,
                        "time": 25.56526,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 9408,
                        "time": 25.56526,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 9504,
                        "time": 25.82613,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9504,
                        "time": 25.82613,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 9552,
                        "time": 25.956564999999998,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9600,
                        "time": 26.087,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 9648,
                        "time": 26.217435,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 9696,
                        "time": 26.34787,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9696,
                        "time": 26.34787,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 9744,
                        "time": 26.478305,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9792,
                        "time": 26.608739999999997,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 9792,
                        "time": 26.608739999999997,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 9888,
                        "time": 26.869609999999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 9888,
                        "time": 26.869609999999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9888,
                        "time": 26.869609999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 9984,
                        "time": 27.13048,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 9984,
                        "time": 27.13048,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 10080,
                        "time": 27.39135,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 10080,
                        "time": 27.39135,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 10176,
                        "time": 27.65222,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10176,
                        "time": 27.65222,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 10272,
                        "time": 27.91309,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 10272,
                        "time": 27.91309,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10320,
                        "time": 28.043525,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 10368,
                        "time": 28.173959999999997,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10416,
                        "time": 28.304395,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 10464,
                        "time": 28.434829999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 10464,
                        "time": 28.434829999999998,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10512,
                        "time": 28.565265,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 10560,
                        "time": 28.6957,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10560,
                        "time": 28.6957,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 10656,
                        "time": 28.95657,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10656,
                        "time": 28.95657,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 10656,
                        "time": 28.95657,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 10752,
                        "time": 29.21744,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10752,
                        "time": 29.21744,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 10848,
                        "time": 29.47831,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 10848,
                        "time": 29.47831,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 10944,
                        "time": 29.739179999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10944,
                        "time": 29.739179999999998,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 11040,
                        "time": 30.000049999999998,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11040,
                        "time": 30.000049999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 11088,
                        "time": 30.130485,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11136,
                        "time": 30.26092,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 11184,
                        "time": 30.391354999999997,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 11232,
                        "time": 30.52179,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11232,
                        "time": 30.52179,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 11280,
                        "time": 30.652224999999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11328,
                        "time": 30.78266,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 11328,
                        "time": 30.78266,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 11424,
                        "time": 31.04353,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 11424,
                        "time": 31.04353,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11424,
                        "time": 31.04353,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11520,
                        "time": 31.304399999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 11520,
                        "time": 31.304399999999998,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 11616,
                        "time": 31.565269999999998,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11616,
                        "time": 31.565269999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11712,
                        "time": 31.82614,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 11712,
                        "time": 31.82614,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 11760,
                        "time": 31.956574999999997,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11808,
                        "time": 32.08701,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 11856,
                        "time": 32.217445,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 11856,
                        "time": 32.217445,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11904,
                        "time": 32.347879999999996,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 11952,
                        "time": 32.478315,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 12000,
                        "time": 32.60875,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 12000,
                        "time": 32.60875,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 12048,
                        "time": 32.739185,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 12096,
                        "time": 32.86962,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 12096,
                        "time": 32.86962,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 12096,
                        "time": 32.86962,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 12192,
                        "time": 33.13049,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 12192,
                        "time": 33.13049,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 12192,
                        "time": 33.13049,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 12288,
                        "time": 33.39136,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 12288,
                        "time": 33.39136,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 12288,
                        "time": 33.39136,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 12336,
                        "time": 33.521795,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 12384,
                        "time": 33.652229999999996,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 12432,
                        "time": 33.782665,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 12480,
                        "time": 33.9131,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 12480,
                        "time": 33.9131,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 12528,
                        "time": 34.043535,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 12576,
                        "time": 34.17397,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 12624,
                        "time": 34.304404999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 12672,
                        "time": 34.43484,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 12720,
                        "time": 34.565275,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 12720,
                        "time": 34.565275,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 12768,
                        "time": 34.69571,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 12816,
                        "time": 34.826145,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 12816,
                        "time": 34.826145,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 12864,
                        "time": 34.956579999999995,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 12864,
                        "time": 34.956579999999995,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 12912,
                        "time": 35.087015,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 12960,
                        "time": 35.21745,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 12960,
                        "time": 35.21745,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 13056,
                        "time": 35.47832,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 13056,
                        "time": 35.47832,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 13104,
                        "time": 35.608755,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 13152,
                        "time": 35.73919,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 13200,
                        "time": 35.869625,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 13248,
                        "time": 36.00006,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 13248,
                        "time": 36.00006,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 13296,
                        "time": 36.130494999999996,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 13344,
                        "time": 36.26093,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 13392,
                        "time": 36.391365,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 13440,
                        "time": 36.5218,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 13488,
                        "time": 36.652235,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 13488,
                        "time": 36.652235,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 13536,
                        "time": 36.782669999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 13584,
                        "time": 36.913105,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 13584,
                        "time": 36.913105,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 13632,
                        "time": 37.04354,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 13632,
                        "time": 37.04354,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 13680,
                        "time": 37.173975,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 13728,
                        "time": 37.30441,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 13728,
                        "time": 37.30441,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 13824,
                        "time": 37.56528,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 13824,
                        "time": 37.56528,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 13872,
                        "time": 37.695715,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 13920,
                        "time": 37.82615,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 13968,
                        "time": 37.956585,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 14016,
                        "time": 38.087019999999995,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 14016,
                        "time": 38.087019999999995,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 14064,
                        "time": 38.217455,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 14112,
                        "time": 38.34789,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 14160,
                        "time": 38.478325,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 14208,
                        "time": 38.60876,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 14256,
                        "time": 38.739194999999995,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 14256,
                        "time": 38.739194999999995,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 14304,
                        "time": 38.86963,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 14352,
                        "time": 39.000065,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 14352,
                        "time": 39.000065,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 14400,
                        "time": 39.1305,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 14400,
                        "time": 39.1305,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 14448,
                        "time": 39.260934999999996,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 14496,
                        "time": 39.39137,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 14496,
                        "time": 39.39137,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 14592,
                        "time": 39.65224,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 14592,
                        "time": 39.65224,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 14640,
                        "time": 39.782675,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 14688,
                        "time": 39.913109999999996,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 14736,
                        "time": 40.043545,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 14784,
                        "time": 40.17398,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 14784,
                        "time": 40.17398,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 14832,
                        "time": 40.304415,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 14832,
                        "time": 40.304415,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 14928,
                        "time": 40.565284999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 14928,
                        "time": 40.565284999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 14976,
                        "time": 40.69572,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 15024,
                        "time": 40.826155,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 15024,
                        "time": 40.826155,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 15024,
                        "time": 40.826155,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 15072,
                        "time": 40.95659,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 15120,
                        "time": 41.087025,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 15120,
                        "time": 41.087025,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 15168,
                        "time": 41.217459999999996,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 15168,
                        "time": 41.217459999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 15168,
                        "time": 41.217459999999996,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 15216,
                        "time": 41.347895,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 15216,
                        "time": 41.347895,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 15264,
                        "time": 41.47833,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 15264,
                        "time": 41.47833,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 15264,
                        "time": 41.47833,
                        "velocity": 0.49606299212598426
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 15360,
                        "time": 41.7392,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 15360,
                        "time": 41.7392,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 15360,
                        "time": 41.7392,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 15456,
                        "time": 42.00007,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 15456,
                        "time": 42.00007,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 15552,
                        "time": 42.26094,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 15552,
                        "time": 42.26094,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 15648,
                        "time": 42.521809999999995,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 15648,
                        "time": 42.521809999999995,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 15696,
                        "time": 42.652245,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 15744,
                        "time": 42.78268,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 15792,
                        "time": 42.913115,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 15840,
                        "time": 43.043549999999996,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 15840,
                        "time": 43.043549999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 15888,
                        "time": 43.173985,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 15936,
                        "time": 43.30442,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 15936,
                        "time": 43.30442,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 16032,
                        "time": 43.56529,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 16032,
                        "time": 43.56529,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 16032,
                        "time": 43.56529,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 16128,
                        "time": 43.82616,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 16128,
                        "time": 43.82616,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 16224,
                        "time": 44.08703,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 16224,
                        "time": 44.08703,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 16320,
                        "time": 44.347899999999996,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 16320,
                        "time": 44.347899999999996,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 16416,
                        "time": 44.60877,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 16416,
                        "time": 44.60877,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 16464,
                        "time": 44.739205,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 16512,
                        "time": 44.86964,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 16560,
                        "time": 45.000074999999995,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 16608,
                        "time": 45.13051,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 16608,
                        "time": 45.13051,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 16656,
                        "time": 45.260945,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 16704,
                        "time": 45.39138,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 16704,
                        "time": 45.39138,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 16800,
                        "time": 45.652249999999995,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 16800,
                        "time": 45.652249999999995,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 16800,
                        "time": 45.652249999999995,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 16896,
                        "time": 45.91312,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 16896,
                        "time": 45.91312,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 16992,
                        "time": 46.173989999999996,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 16992,
                        "time": 46.173989999999996,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 17088,
                        "time": 46.43486,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 17088,
                        "time": 46.43486,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 17184,
                        "time": 46.69573,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 17184,
                        "time": 46.69573,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 17232,
                        "time": 46.826164999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 17280,
                        "time": 46.9566,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 17328,
                        "time": 47.087035,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 17376,
                        "time": 47.21747,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 17376,
                        "time": 47.21747,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 17424,
                        "time": 47.347905,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 17472,
                        "time": 47.478339999999996,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 17472,
                        "time": 47.478339999999996,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 17568,
                        "time": 47.73921,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 17568,
                        "time": 47.73921,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 17568,
                        "time": 47.73921,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 17664,
                        "time": 48.00008,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 17664,
                        "time": 48.00008,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 17760,
                        "time": 48.26095,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 17760,
                        "time": 48.26095,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 17856,
                        "time": 48.52182,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 17856,
                        "time": 48.52182,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 17904,
                        "time": 48.652255,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 17952,
                        "time": 48.782689999999995,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 18000,
                        "time": 48.913125,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 18000,
                        "time": 48.913125,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18048,
                        "time": 49.04356,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 18096,
                        "time": 49.173995,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 18096,
                        "time": 49.173995,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 18144,
                        "time": 49.304429999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18144,
                        "time": 49.304429999999996,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 18192,
                        "time": 49.434864999999995,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 18192,
                        "time": 49.434864999999995,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18240,
                        "time": 49.5653,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 18240,
                        "time": 49.5653,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 18240,
                        "time": 49.5653,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 18288,
                        "time": 49.695735,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 18336,
                        "time": 49.82617,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 18336,
                        "time": 49.82617,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18336,
                        "time": 49.82617,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 18432,
                        "time": 50.08704,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18432,
                        "time": 50.08704,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 18432,
                        "time": 50.08704,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 18432,
                        "time": 50.08704,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18528,
                        "time": 50.34791,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 18528,
                        "time": 50.34791,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18624,
                        "time": 50.608779999999996,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 18624,
                        "time": 50.608779999999996,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18720,
                        "time": 50.86965,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 18720,
                        "time": 50.86965,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 18768,
                        "time": 51.000085,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18816,
                        "time": 51.13052,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 18864,
                        "time": 51.260954999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18912,
                        "time": 51.39139,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 18912,
                        "time": 51.39139,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 18960,
                        "time": 51.521825,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 19008,
                        "time": 51.65226,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 19008,
                        "time": 51.65226,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 19104,
                        "time": 51.913129999999995,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 19104,
                        "time": 51.913129999999995,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 19104,
                        "time": 51.913129999999995,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 19200,
                        "time": 52.174,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 19200,
                        "time": 52.174,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 19296,
                        "time": 52.43487,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 19296,
                        "time": 52.43487,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 19392,
                        "time": 52.69574,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 19392,
                        "time": 52.69574,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 19488,
                        "time": 52.95661,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 19488,
                        "time": 52.95661,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 19536,
                        "time": 53.087044999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 19584,
                        "time": 53.217479999999995,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 19632,
                        "time": 53.347915,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 19680,
                        "time": 53.47835,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 19680,
                        "time": 53.47835,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 19728,
                        "time": 53.608785,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 19776,
                        "time": 53.739219999999996,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 19776,
                        "time": 53.739219999999996,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 19872,
                        "time": 54.00009,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 19872,
                        "time": 54.00009,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 19872,
                        "time": 54.00009,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 19968,
                        "time": 54.26096,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 19968,
                        "time": 54.26096,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 20064,
                        "time": 54.52183,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 20064,
                        "time": 54.52183,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 20160,
                        "time": 54.7827,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 20160,
                        "time": 54.7827,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 20256,
                        "time": 55.043569999999995,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 20256,
                        "time": 55.043569999999995,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 20304,
                        "time": 55.174005,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 20352,
                        "time": 55.30444,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 20400,
                        "time": 55.434875,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 20448,
                        "time": 55.56531,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 20448,
                        "time": 55.56531,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 20496,
                        "time": 55.695744999999995,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 20544,
                        "time": 55.82618,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 20544,
                        "time": 55.82618,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 20640,
                        "time": 56.08705,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 20640,
                        "time": 56.08705,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 20640,
                        "time": 56.08705,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 20736,
                        "time": 56.347919999999995,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 20736,
                        "time": 56.347919999999995,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 20832,
                        "time": 56.60879,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 20832,
                        "time": 56.60879,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 20928,
                        "time": 56.869659999999996,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 20928,
                        "time": 56.869659999999996,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 20976,
                        "time": 57.000094999999995,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21024,
                        "time": 57.13053,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 21072,
                        "time": 57.260965,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 21072,
                        "time": 57.260965,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21120,
                        "time": 57.3914,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 21168,
                        "time": 57.521834999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 21168,
                        "time": 57.521834999999996,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 21216,
                        "time": 57.65227,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21216,
                        "time": 57.65227,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 21264,
                        "time": 57.782705,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 21264,
                        "time": 57.782705,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 21264,
                        "time": 57.782705,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21312,
                        "time": 57.91314,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 21312,
                        "time": 57.91314,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 21360,
                        "time": 58.043575,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 21360,
                        "time": 58.043575,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 21408,
                        "time": 58.174009999999996,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 21408,
                        "time": 58.174009999999996,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21408,
                        "time": 58.174009999999996,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 21504,
                        "time": 58.43488,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 21504,
                        "time": 58.43488,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21504,
                        "time": 58.43488,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 21504,
                        "time": 58.43488,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 21504,
                        "time": 58.43488,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21600,
                        "time": 58.69575,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 21600,
                        "time": 58.69575,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 21696,
                        "time": 58.95662,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21696,
                        "time": 58.95662,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 21792,
                        "time": 59.21749,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21792,
                        "time": 59.21749,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 21840,
                        "time": 59.347925,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21888,
                        "time": 59.478359999999995,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 21936,
                        "time": 59.608795,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 21984,
                        "time": 59.73923,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21984,
                        "time": 59.73923,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 22032,
                        "time": 59.869665,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 22080,
                        "time": 60.000099999999996,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 22080,
                        "time": 60.000099999999996,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 22176,
                        "time": 60.26097,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 22176,
                        "time": 60.26097,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 22176,
                        "time": 60.26097,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 22272,
                        "time": 60.52184,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 22272,
                        "time": 60.52184,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 22368,
                        "time": 60.782709999999994,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 22368,
                        "time": 60.782709999999994,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 22464,
                        "time": 61.04358,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 22464,
                        "time": 61.04358,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 22560,
                        "time": 61.304449999999996,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 22560,
                        "time": 61.304449999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 22608,
                        "time": 61.434885,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 22656,
                        "time": 61.56532,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 22704,
                        "time": 61.695755,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 22752,
                        "time": 61.82619,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 22752,
                        "time": 61.82619,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 22800,
                        "time": 61.956624999999995,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 22848,
                        "time": 62.08706,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 22848,
                        "time": 62.08706,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 22944,
                        "time": 62.34793,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 22944,
                        "time": 62.34793,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 22944,
                        "time": 62.34793,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 23040,
                        "time": 62.608799999999995,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 23040,
                        "time": 62.608799999999995,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 23136,
                        "time": 62.86967,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 23136,
                        "time": 62.86967,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 23232,
                        "time": 63.130539999999996,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 23232,
                        "time": 63.130539999999996,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 23328,
                        "time": 63.39141,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 23328,
                        "time": 63.39141,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 23376,
                        "time": 63.521845,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 23424,
                        "time": 63.65228,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 23472,
                        "time": 63.782714999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 23520,
                        "time": 63.913149999999995,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 23520,
                        "time": 63.913149999999995,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 23568,
                        "time": 64.043585,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 23616,
                        "time": 64.17402,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 23616,
                        "time": 64.17402,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 23712,
                        "time": 64.43489,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 23712,
                        "time": 64.43489,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 23712,
                        "time": 64.43489,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 23808,
                        "time": 64.69575999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 23808,
                        "time": 64.69575999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 23904,
                        "time": 64.95663,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 23904,
                        "time": 64.95663,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 24000,
                        "time": 65.2175,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24000,
                        "time": 65.2175,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 24048,
                        "time": 65.34793499999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24096,
                        "time": 65.47837,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 24144,
                        "time": 65.608805,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 24144,
                        "time": 65.608805,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24192,
                        "time": 65.73924,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 24240,
                        "time": 65.869675,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 24240,
                        "time": 65.869675,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24288,
                        "time": 66.00010999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 24288,
                        "time": 66.00010999999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 24336,
                        "time": 66.130545,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 24336,
                        "time": 66.130545,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 24336,
                        "time": 66.130545,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 24384,
                        "time": 66.26098,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24384,
                        "time": 66.26098,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 24432,
                        "time": 66.391415,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 24432,
                        "time": 66.391415,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 24480,
                        "time": 66.52185,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 24480,
                        "time": 66.52185,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24480,
                        "time": 66.52185,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 24576,
                        "time": 66.78272,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24576,
                        "time": 66.78272,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 24576,
                        "time": 66.78272,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 24576,
                        "time": 66.78272,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 24576,
                        "time": 66.78272,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24672,
                        "time": 67.04359,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 24672,
                        "time": 67.04359,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 24768,
                        "time": 67.30445999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24768,
                        "time": 67.30445999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 24864,
                        "time": 67.56533,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24864,
                        "time": 67.56533,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 24912,
                        "time": 67.695765,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24960,
                        "time": 67.8262,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 25008,
                        "time": 67.95663499999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 25056,
                        "time": 68.08707,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 25056,
                        "time": 68.08707,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 25104,
                        "time": 68.217505,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 25152,
                        "time": 68.34794,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 25152,
                        "time": 68.34794,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 25248,
                        "time": 68.60880999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 25248,
                        "time": 68.60880999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 25248,
                        "time": 68.60880999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 25344,
                        "time": 68.86968,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 25344,
                        "time": 68.86968,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 25440,
                        "time": 69.13055,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 25440,
                        "time": 69.13055,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 25536,
                        "time": 69.39142,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 25536,
                        "time": 69.39142,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 25632,
                        "time": 69.65229,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 25632,
                        "time": 69.65229,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 25680,
                        "time": 69.782725,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 25728,
                        "time": 69.91315999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 25776,
                        "time": 70.043595,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 25824,
                        "time": 70.17403,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 25824,
                        "time": 70.17403,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 25872,
                        "time": 70.304465,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 25920,
                        "time": 70.4349,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 25920,
                        "time": 70.4349,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 26016,
                        "time": 70.69577,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 26016,
                        "time": 70.69577,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 26016,
                        "time": 70.69577,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 26112,
                        "time": 70.95664,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 26112,
                        "time": 70.95664,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 26208,
                        "time": 71.21751,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 26208,
                        "time": 71.21751,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 26304,
                        "time": 71.47838,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 26304,
                        "time": 71.47838,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 26400,
                        "time": 71.73925,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 26400,
                        "time": 71.73925,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 26448,
                        "time": 71.869685,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 26496,
                        "time": 72.00012,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 26544,
                        "time": 72.130555,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 26592,
                        "time": 72.26098999999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 26592,
                        "time": 72.26098999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 26640,
                        "time": 72.391425,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 26688,
                        "time": 72.52186,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 26688,
                        "time": 72.52186,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 26784,
                        "time": 72.78273,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 26784,
                        "time": 72.78273,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 26784,
                        "time": 72.78273,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 26880,
                        "time": 73.0436,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 26880,
                        "time": 73.0436,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 26976,
                        "time": 73.30447,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 26976,
                        "time": 73.30447,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 27072,
                        "time": 73.56533999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 27072,
                        "time": 73.56533999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 27120,
                        "time": 73.695775,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 27168,
                        "time": 73.82621,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 27216,
                        "time": 73.956645,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 27216,
                        "time": 73.956645,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 27264,
                        "time": 74.08708,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 27312,
                        "time": 74.21751499999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 27312,
                        "time": 74.21751499999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 27360,
                        "time": 74.34795,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 27360,
                        "time": 74.34795,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 27408,
                        "time": 74.478385,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 27408,
                        "time": 74.478385,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 27408,
                        "time": 74.478385,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 27456,
                        "time": 74.60882,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 27456,
                        "time": 74.60882,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 27504,
                        "time": 74.739255,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 27504,
                        "time": 74.739255,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 27552,
                        "time": 74.86968999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 27552,
                        "time": 74.86968999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 27552,
                        "time": 74.86968999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 27648,
                        "time": 75.13056,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 27648,
                        "time": 75.13056,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 27648,
                        "time": 75.13056,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 27648,
                        "time": 75.13056,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 27648,
                        "time": 75.13056,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 27744,
                        "time": 75.39143,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 27744,
                        "time": 75.39143,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 27840,
                        "time": 75.6523,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 27840,
                        "time": 75.6523,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 27936,
                        "time": 75.91317,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 27936,
                        "time": 75.91317,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 27984,
                        "time": 76.043605,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 28032,
                        "time": 76.17403999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 28080,
                        "time": 76.304475,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 28128,
                        "time": 76.43491,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 28128,
                        "time": 76.43491,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 28176,
                        "time": 76.565345,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 28224,
                        "time": 76.69578,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 28224,
                        "time": 76.69578,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 28320,
                        "time": 76.95665,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 28320,
                        "time": 76.95665,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 28320,
                        "time": 76.95665,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 28416,
                        "time": 77.21752,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 28416,
                        "time": 77.21752,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 28512,
                        "time": 77.47838999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 28512,
                        "time": 77.47838999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 28608,
                        "time": 77.73926,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 28608,
                        "time": 77.73926,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 28704,
                        "time": 78.00013,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 28704,
                        "time": 78.00013,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 28752,
                        "time": 78.130565,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 28800,
                        "time": 78.261,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 28848,
                        "time": 78.391435,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 28896,
                        "time": 78.52186999999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 28896,
                        "time": 78.52186999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 28944,
                        "time": 78.652305,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 28992,
                        "time": 78.78274,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 28992,
                        "time": 78.78274,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 29088,
                        "time": 79.04361,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 29088,
                        "time": 79.04361,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 29088,
                        "time": 79.04361,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 29184,
                        "time": 79.30448,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 29184,
                        "time": 79.30448,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 29280,
                        "time": 79.56535,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 29280,
                        "time": 79.56535,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 29376,
                        "time": 79.82621999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 29376,
                        "time": 79.82621999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 29472,
                        "time": 80.08709,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 29472,
                        "time": 80.08709,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 29520,
                        "time": 80.217525,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 29568,
                        "time": 80.34796,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 29616,
                        "time": 80.47839499999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 29664,
                        "time": 80.60883,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 29664,
                        "time": 80.60883,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 29712,
                        "time": 80.739265,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 29760,
                        "time": 80.8697,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 29760,
                        "time": 80.8697,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 29856,
                        "time": 81.13056999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 29856,
                        "time": 81.13056999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 29856,
                        "time": 81.13056999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 29952,
                        "time": 81.39144,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 29952,
                        "time": 81.39144,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 30048,
                        "time": 81.65231,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 30048,
                        "time": 81.65231,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 30144,
                        "time": 81.91318,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 30144,
                        "time": 81.91318,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 30192,
                        "time": 82.043615,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 30240,
                        "time": 82.17405,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 30288,
                        "time": 82.304485,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 30288,
                        "time": 82.304485,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 30336,
                        "time": 82.43491999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 30384,
                        "time": 82.565355,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 30384,
                        "time": 82.565355,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 30432,
                        "time": 82.69579,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 30432,
                        "time": 82.69579,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 30480,
                        "time": 82.826225,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 30480,
                        "time": 82.826225,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 30480,
                        "time": 82.826225,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 30528,
                        "time": 82.95666,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 30528,
                        "time": 82.95666,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 30576,
                        "time": 83.08709499999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 30576,
                        "time": 83.08709499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 30624,
                        "time": 83.21753,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 30624,
                        "time": 83.21753,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 30624,
                        "time": 83.21753,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 30720,
                        "time": 83.4784,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 30720,
                        "time": 83.4784,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 30720,
                        "time": 83.4784,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 30816,
                        "time": 83.73926999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 30912,
                        "time": 84.00014,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 30912,
                        "time": 84.00014,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 31008,
                        "time": 84.26101,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 31056,
                        "time": 84.39144499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 31104,
                        "time": 84.52188,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 31152,
                        "time": 84.652315,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 31200,
                        "time": 84.78275,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 31248,
                        "time": 84.913185,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 31296,
                        "time": 85.04361999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 31296,
                        "time": 85.04361999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 31296,
                        "time": 85.04361999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 31392,
                        "time": 85.30449,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 31440,
                        "time": 85.43492499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 31488,
                        "time": 85.56536,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 31488,
                        "time": 85.56536,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 31584,
                        "time": 85.82623,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 31680,
                        "time": 86.08709999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 31680,
                        "time": 86.08709999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 31776,
                        "time": 86.34797,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 31824,
                        "time": 86.478405,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 31872,
                        "time": 86.60884,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 31920,
                        "time": 86.73927499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 31968,
                        "time": 86.86971,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 32016,
                        "time": 87.000145,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 32064,
                        "time": 87.13058,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 32064,
                        "time": 87.13058,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 32064,
                        "time": 87.13058,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 32160,
                        "time": 87.39144999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 32208,
                        "time": 87.521885,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 32256,
                        "time": 87.65232,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 32256,
                        "time": 87.65232,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 32352,
                        "time": 87.91319,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 32448,
                        "time": 88.17406,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 32448,
                        "time": 88.17406,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 32544,
                        "time": 88.43493,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 32592,
                        "time": 88.565365,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 32640,
                        "time": 88.69579999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 32688,
                        "time": 88.826235,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 32736,
                        "time": 88.95667,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 32784,
                        "time": 89.087105,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 32832,
                        "time": 89.21754,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 32832,
                        "time": 89.21754,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 32832,
                        "time": 89.21754,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 32928,
                        "time": 89.47841,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 32976,
                        "time": 89.608845,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 33024,
                        "time": 89.73928,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 33024,
                        "time": 89.73928,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 33120,
                        "time": 90.00014999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 33216,
                        "time": 90.26102,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 33216,
                        "time": 90.26102,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 33312,
                        "time": 90.52189,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 33360,
                        "time": 90.65232499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 33408,
                        "time": 90.78276,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 33456,
                        "time": 90.913195,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 33504,
                        "time": 91.04363,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 33552,
                        "time": 91.174065,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 33600,
                        "time": 91.30449999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 33600,
                        "time": 91.30449999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 33600,
                        "time": 91.30449999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 33696,
                        "time": 91.56537,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 33744,
                        "time": 91.695805,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 33792,
                        "time": 91.82624,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 33792,
                        "time": 91.82624,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 33888,
                        "time": 92.08711,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 33984,
                        "time": 92.34797999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 33984,
                        "time": 92.34797999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 34080,
                        "time": 92.60884999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 34128,
                        "time": 92.739285,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 34176,
                        "time": 92.86972,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 34224,
                        "time": 93.00015499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 34272,
                        "time": 93.13059,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 34320,
                        "time": 93.261025,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 34368,
                        "time": 93.39146,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 34368,
                        "time": 93.39146,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 34368,
                        "time": 93.39146,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 34464,
                        "time": 93.65232999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 34512,
                        "time": 93.782765,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 34560,
                        "time": 93.9132,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 34560,
                        "time": 93.9132,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 34656,
                        "time": 94.17407,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 34752,
                        "time": 94.43494,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 34752,
                        "time": 94.43494,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 34848,
                        "time": 94.69581,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 34896,
                        "time": 94.826245,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 34944,
                        "time": 94.95667999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 34992,
                        "time": 95.087115,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 35040,
                        "time": 95.21755,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 35088,
                        "time": 95.347985,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 35136,
                        "time": 95.47842,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 35136,
                        "time": 95.47842,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 35136,
                        "time": 95.47842,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 35232,
                        "time": 95.73929,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 35280,
                        "time": 95.869725,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 35328,
                        "time": 96.00016,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 35328,
                        "time": 96.00016,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 35424,
                        "time": 96.26102999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 35520,
                        "time": 96.5219,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 35520,
                        "time": 96.5219,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 35616,
                        "time": 96.78277,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 35664,
                        "time": 96.91320499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 35712,
                        "time": 97.04364,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 35760,
                        "time": 97.174075,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 35808,
                        "time": 97.30451,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 35856,
                        "time": 97.434945,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 35904,
                        "time": 97.56537999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 35904,
                        "time": 97.56537999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 35904,
                        "time": 97.56537999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 36000,
                        "time": 97.82625,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 36048,
                        "time": 97.956685,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 36096,
                        "time": 98.08712,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 36096,
                        "time": 98.08712,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 36192,
                        "time": 98.34799,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 36288,
                        "time": 98.60885999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 36288,
                        "time": 98.60885999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 36384,
                        "time": 98.86972999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 36432,
                        "time": 99.000165,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 36480,
                        "time": 99.1306,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 36528,
                        "time": 99.26103499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 36576,
                        "time": 99.39147,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 36624,
                        "time": 99.52190499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 36672,
                        "time": 99.65234,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 36672,
                        "time": 99.65234,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 36672,
                        "time": 99.65234,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 36768,
                        "time": 99.91320999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 36816,
                        "time": 100.043645,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 36864,
                        "time": 100.17408,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 36864,
                        "time": 100.17408,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 36864,
                        "time": 100.17408,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 36960,
                        "time": 100.43495,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 37056,
                        "time": 100.69582,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 37056,
                        "time": 100.69582,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 37152,
                        "time": 100.95669,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 37200,
                        "time": 101.087125,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 37248,
                        "time": 101.21755999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 37296,
                        "time": 101.347995,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 37344,
                        "time": 101.47843,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 37392,
                        "time": 101.608865,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 37440,
                        "time": 101.7393,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 37440,
                        "time": 101.7393,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 37440,
                        "time": 101.7393,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 37536,
                        "time": 102.00017,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 37584,
                        "time": 102.130605,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 37632,
                        "time": 102.26104,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 37632,
                        "time": 102.26104,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 37728,
                        "time": 102.52190999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 37824,
                        "time": 102.78278,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 37824,
                        "time": 102.78278,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 37920,
                        "time": 103.04365,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 37968,
                        "time": 103.17408499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 38016,
                        "time": 103.30452,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 38064,
                        "time": 103.434955,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 38112,
                        "time": 103.56539,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 38160,
                        "time": 103.695825,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 38208,
                        "time": 103.82625999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 38208,
                        "time": 103.82625999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 38208,
                        "time": 103.82625999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 38304,
                        "time": 104.08713,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 38352,
                        "time": 104.217565,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 38400,
                        "time": 104.348,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 38400,
                        "time": 104.348,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 38496,
                        "time": 104.60887,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 38592,
                        "time": 104.86974,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 38592,
                        "time": 104.86974,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 38688,
                        "time": 105.13060999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 38736,
                        "time": 105.261045,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 38784,
                        "time": 105.39148,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 38832,
                        "time": 105.52191499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 38880,
                        "time": 105.65235,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 38928,
                        "time": 105.78278499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 38976,
                        "time": 105.91322,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 38976,
                        "time": 105.91322,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 38976,
                        "time": 105.91322,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 39072,
                        "time": 106.17408999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 39120,
                        "time": 106.304525,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 39168,
                        "time": 106.43495999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 39168,
                        "time": 106.43495999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 39264,
                        "time": 106.69583,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 39360,
                        "time": 106.9567,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 39360,
                        "time": 106.9567,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 39456,
                        "time": 107.21757,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 39504,
                        "time": 107.348005,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 39552,
                        "time": 107.47843999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 39600,
                        "time": 107.608875,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 39648,
                        "time": 107.73931,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 39696,
                        "time": 107.869745,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 39744,
                        "time": 108.00018,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 39744,
                        "time": 108.00018,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 39744,
                        "time": 108.00018,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 39840,
                        "time": 108.26105,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 39888,
                        "time": 108.391485,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 39936,
                        "time": 108.52192,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 39936,
                        "time": 108.52192,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 40032,
                        "time": 108.78278999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 40128,
                        "time": 109.04366,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 40128,
                        "time": 109.04366,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 40224,
                        "time": 109.30453,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 40272,
                        "time": 109.43496499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 40320,
                        "time": 109.5654,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 40368,
                        "time": 109.695835,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 40416,
                        "time": 109.82627,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 40464,
                        "time": 109.956705,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 40512,
                        "time": 110.08713999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 40512,
                        "time": 110.08713999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 40512,
                        "time": 110.08713999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 40608,
                        "time": 110.34801,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 40656,
                        "time": 110.478445,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 40704,
                        "time": 110.60888,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 40704,
                        "time": 110.60888,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 40800,
                        "time": 110.86975,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 40896,
                        "time": 111.13062,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 40896,
                        "time": 111.13062,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 40992,
                        "time": 111.39148999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 41040,
                        "time": 111.521925,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 41088,
                        "time": 111.65236,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 41136,
                        "time": 111.782795,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 41184,
                        "time": 111.91323,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 41232,
                        "time": 112.04366499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 41280,
                        "time": 112.1741,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 41280,
                        "time": 112.1741,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 41280,
                        "time": 112.1741,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 44,
                        "name": "G#2",
                        "ticks": 41376,
                        "time": 112.43496999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 41424,
                        "time": 112.565405,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 42672,
                        "time": 115.956715,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 42768,
                        "time": 116.217585,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 42864,
                        "time": 116.478455,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 43008,
                        "time": 116.86976,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43008,
                        "time": 116.86976,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 43008,
                        "time": 116.86976,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 43104,
                        "time": 117.13063,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43104,
                        "time": 117.13063,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43200,
                        "time": 117.3915,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 43200,
                        "time": 117.3915,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 43296,
                        "time": 117.65236999999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43296,
                        "time": 117.65236999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 43344,
                        "time": 117.782805,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43392,
                        "time": 117.91324,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 43440,
                        "time": 118.043675,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 43488,
                        "time": 118.17411,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43488,
                        "time": 118.17411,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 43536,
                        "time": 118.30454499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43584,
                        "time": 118.43498,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 43584,
                        "time": 118.43498,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 43680,
                        "time": 118.69585,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 43680,
                        "time": 118.69585,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43680,
                        "time": 118.69585,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43776,
                        "time": 118.95671999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 43776,
                        "time": 118.95671999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 43872,
                        "time": 119.21759,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43872,
                        "time": 119.21759,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43968,
                        "time": 119.47846,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 43968,
                        "time": 119.47846,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 44064,
                        "time": 119.73933,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 44064,
                        "time": 119.73933,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 44112,
                        "time": 119.869765,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 44160,
                        "time": 120.00019999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 44208,
                        "time": 120.130635,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 44256,
                        "time": 120.26106999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 44256,
                        "time": 120.26106999999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 44304,
                        "time": 120.391505,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 44352,
                        "time": 120.52194,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 44352,
                        "time": 120.52194,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 44448,
                        "time": 120.78281,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 44448,
                        "time": 120.78281,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 44448,
                        "time": 120.78281,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 44544,
                        "time": 121.04368,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 44544,
                        "time": 121.04368,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 44640,
                        "time": 121.30454999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 44640,
                        "time": 121.30454999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 44736,
                        "time": 121.56541999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 44736,
                        "time": 121.56541999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 44832,
                        "time": 121.82629,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 44832,
                        "time": 121.82629,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 44880,
                        "time": 121.95672499999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 44928,
                        "time": 122.08716,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 44976,
                        "time": 122.21759499999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 45024,
                        "time": 122.34803,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 45024,
                        "time": 122.34803,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 45072,
                        "time": 122.478465,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 45120,
                        "time": 122.60889999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 45120,
                        "time": 122.60889999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 45216,
                        "time": 122.86977,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 45216,
                        "time": 122.86977,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 45216,
                        "time": 122.86977,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 45312,
                        "time": 123.13064,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 45312,
                        "time": 123.13064,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 45408,
                        "time": 123.39151,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 45408,
                        "time": 123.39151,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 45504,
                        "time": 123.65238,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 45504,
                        "time": 123.65238,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 45552,
                        "time": 123.782815,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 45600,
                        "time": 123.91324999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 45648,
                        "time": 124.043685,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 45648,
                        "time": 124.043685,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 45696,
                        "time": 124.17412,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 45744,
                        "time": 124.304555,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 45744,
                        "time": 124.304555,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 45792,
                        "time": 124.43499,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 45792,
                        "time": 124.43499,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 45840,
                        "time": 124.56542499999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 45840,
                        "time": 124.56542499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 45888,
                        "time": 124.69586,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 45888,
                        "time": 124.69586,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 45888,
                        "time": 124.69586,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 45936,
                        "time": 124.826295,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 45984,
                        "time": 124.95673,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 45984,
                        "time": 124.95673,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 45984,
                        "time": 124.95673,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 46080,
                        "time": 125.21759999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46080,
                        "time": 125.21759999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 46080,
                        "time": 125.21759999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 46080,
                        "time": 125.21759999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 46176,
                        "time": 125.47847,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46176,
                        "time": 125.47847,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46272,
                        "time": 125.73934,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 46272,
                        "time": 125.73934,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 46368,
                        "time": 126.00021,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46368,
                        "time": 126.00021,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 46416,
                        "time": 126.130645,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46464,
                        "time": 126.26107999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 46512,
                        "time": 126.391515,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 46560,
                        "time": 126.52194999999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46560,
                        "time": 126.52194999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 46608,
                        "time": 126.652385,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46656,
                        "time": 126.78282,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 46656,
                        "time": 126.78282,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 46752,
                        "time": 127.04369,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 46752,
                        "time": 127.04369,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46752,
                        "time": 127.04369,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46848,
                        "time": 127.30456,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 46848,
                        "time": 127.30456,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 46944,
                        "time": 127.56542999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46944,
                        "time": 127.56542999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 47040,
                        "time": 127.82629999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 47040,
                        "time": 127.82629999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 47136,
                        "time": 128.08717,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 47136,
                        "time": 128.08717,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 47184,
                        "time": 128.217605,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 47232,
                        "time": 128.34804,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 47280,
                        "time": 128.478475,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 47328,
                        "time": 128.60891,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 47328,
                        "time": 128.60891,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 47376,
                        "time": 128.739345,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 47424,
                        "time": 128.86978,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 47424,
                        "time": 128.86978,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 47520,
                        "time": 129.13065,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 47520,
                        "time": 129.13065,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 47520,
                        "time": 129.13065,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 47616,
                        "time": 129.39151999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 47616,
                        "time": 129.39151999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 47712,
                        "time": 129.65239,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 47712,
                        "time": 129.65239,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 47808,
                        "time": 129.91326,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 47808,
                        "time": 129.91326,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 47904,
                        "time": 130.17413,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 47904,
                        "time": 130.17413,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 47952,
                        "time": 130.304565,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 48000,
                        "time": 130.435,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 48048,
                        "time": 130.565435,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 48096,
                        "time": 130.69586999999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 48096,
                        "time": 130.69586999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 48144,
                        "time": 130.826305,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 48192,
                        "time": 130.95674,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 48192,
                        "time": 130.95674,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 48288,
                        "time": 131.21761,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 48288,
                        "time": 131.21761,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 48288,
                        "time": 131.21761,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 48384,
                        "time": 131.47848,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 48384,
                        "time": 131.47848,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 48480,
                        "time": 131.73935,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 48480,
                        "time": 131.73935,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 48576,
                        "time": 132.00021999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 48576,
                        "time": 132.00021999999998,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 48624,
                        "time": 132.130655,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 48672,
                        "time": 132.26109,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 48720,
                        "time": 132.391525,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 48720,
                        "time": 132.391525,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 48768,
                        "time": 132.52196,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 48816,
                        "time": 132.65239499999998,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 48816,
                        "time": 132.65239499999998,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 48864,
                        "time": 132.78283,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 48864,
                        "time": 132.78283,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 48912,
                        "time": 132.913265,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 48912,
                        "time": 132.913265,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 48912,
                        "time": 132.913265,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 48960,
                        "time": 133.0437,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 48960,
                        "time": 133.0437,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 49008,
                        "time": 133.174135,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 49008,
                        "time": 133.174135,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49056,
                        "time": 133.30456999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 49056,
                        "time": 133.30456999999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 49056,
                        "time": 133.30456999999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 49152,
                        "time": 133.56544,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49152,
                        "time": 133.56544,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 49152,
                        "time": 133.56544,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49248,
                        "time": 133.82631,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 49248,
                        "time": 133.82631,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49344,
                        "time": 134.08718,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 49344,
                        "time": 134.08718,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49440,
                        "time": 134.34805,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 49440,
                        "time": 134.34805,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 49488,
                        "time": 134.478485,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49536,
                        "time": 134.60891999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 49584,
                        "time": 134.739355,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49632,
                        "time": 134.86979,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 49632,
                        "time": 134.86979,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 49680,
                        "time": 135.000225,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49728,
                        "time": 135.13066,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 49728,
                        "time": 135.13066,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49824,
                        "time": 135.39153,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 49824,
                        "time": 135.39153,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 49824,
                        "time": 135.39153,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49920,
                        "time": 135.6524,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 49920,
                        "time": 135.6524,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 50016,
                        "time": 135.91326999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 50016,
                        "time": 135.91326999999998,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 50112,
                        "time": 136.17414,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 50112,
                        "time": 136.17414,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 50208,
                        "time": 136.43501,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 50208,
                        "time": 136.43501,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 50256,
                        "time": 136.56544499999998,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 50304,
                        "time": 136.69588,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 50352,
                        "time": 136.826315,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 50400,
                        "time": 136.95675,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 50400,
                        "time": 136.95675,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 50448,
                        "time": 137.087185,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 50496,
                        "time": 137.21761999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 50496,
                        "time": 137.21761999999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 50592,
                        "time": 137.47849,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 50592,
                        "time": 137.47849,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 50592,
                        "time": 137.47849,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 50688,
                        "time": 137.73936,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 50688,
                        "time": 137.73936,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 50784,
                        "time": 138.00023,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 50784,
                        "time": 138.00023,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 50880,
                        "time": 138.2611,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 50880,
                        "time": 138.2611,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 50976,
                        "time": 138.52196999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 50976,
                        "time": 138.52196999999998,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 51024,
                        "time": 138.652405,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 51072,
                        "time": 138.78284,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 51120,
                        "time": 138.913275,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 51168,
                        "time": 139.04371,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 51168,
                        "time": 139.04371,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 51216,
                        "time": 139.17414499999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 51264,
                        "time": 139.30458,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 51264,
                        "time": 139.30458,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 51360,
                        "time": 139.56545,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 51360,
                        "time": 139.56545,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 51360,
                        "time": 139.56545,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 51456,
                        "time": 139.82631999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 51456,
                        "time": 139.82631999999998,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 51552,
                        "time": 140.08719,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 51552,
                        "time": 140.08719,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 51648,
                        "time": 140.34806,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 51648,
                        "time": 140.34806,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 51696,
                        "time": 140.47849499999998,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 51744,
                        "time": 140.60893,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 51792,
                        "time": 140.739365,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 51792,
                        "time": 140.739365,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 51840,
                        "time": 140.8698,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 51888,
                        "time": 141.000235,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 51888,
                        "time": 141.000235,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 51936,
                        "time": 141.13067,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 51936,
                        "time": 141.13067,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 51984,
                        "time": 141.261105,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 51984,
                        "time": 141.261105,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52032,
                        "time": 141.39154,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 52032,
                        "time": 141.39154,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 52032,
                        "time": 141.39154,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 52080,
                        "time": 141.521975,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 52128,
                        "time": 141.65241,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 52128,
                        "time": 141.65241,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52128,
                        "time": 141.65241,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 52224,
                        "time": 141.91328,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52224,
                        "time": 141.91328,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 52224,
                        "time": 141.91328,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 52224,
                        "time": 141.91328,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52320,
                        "time": 142.17415,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 52320,
                        "time": 142.17415,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52416,
                        "time": 142.43502,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 52416,
                        "time": 142.43502,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52512,
                        "time": 142.69589,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 52512,
                        "time": 142.69589,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 52560,
                        "time": 142.826325,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52608,
                        "time": 142.95676,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 52656,
                        "time": 143.087195,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52704,
                        "time": 143.21762999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 52704,
                        "time": 143.21762999999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 52752,
                        "time": 143.348065,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52800,
                        "time": 143.4785,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 52800,
                        "time": 143.4785,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52896,
                        "time": 143.73937,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 52896,
                        "time": 143.73937,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 52896,
                        "time": 143.73937,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52992,
                        "time": 144.00024,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 52992,
                        "time": 144.00024,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 53088,
                        "time": 144.26111,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 53088,
                        "time": 144.26111,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 53184,
                        "time": 144.52197999999999,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 53184,
                        "time": 144.52197999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 53280,
                        "time": 144.78285,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 53280,
                        "time": 144.78285,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 53328,
                        "time": 144.913285,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 53376,
                        "time": 145.04372,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 53424,
                        "time": 145.17415499999998,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 53472,
                        "time": 145.30459,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 53472,
                        "time": 145.30459,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 53520,
                        "time": 145.435025,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 53568,
                        "time": 145.56546,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 53568,
                        "time": 145.56546,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 53664,
                        "time": 145.82632999999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 53664,
                        "time": 145.82632999999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 53664,
                        "time": 145.82632999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 53760,
                        "time": 146.0872,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 53760,
                        "time": 146.0872,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 53856,
                        "time": 146.34807,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 53856,
                        "time": 146.34807,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 53952,
                        "time": 146.60894,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 53952,
                        "time": 146.60894,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 54048,
                        "time": 146.86981,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 54048,
                        "time": 146.86981,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 54096,
                        "time": 147.000245,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 54144,
                        "time": 147.13067999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 54192,
                        "time": 147.261115,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 54240,
                        "time": 147.39155,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 54240,
                        "time": 147.39155,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 54288,
                        "time": 147.521985,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 54336,
                        "time": 147.65242,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 54336,
                        "time": 147.65242,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 54432,
                        "time": 147.91329,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 54432,
                        "time": 147.91329,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 54432,
                        "time": 147.91329,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 54528,
                        "time": 148.17416,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 54528,
                        "time": 148.17416,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 54624,
                        "time": 148.43502999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 54624,
                        "time": 148.43502999999998,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 54720,
                        "time": 148.6959,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 54720,
                        "time": 148.6959,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 54768,
                        "time": 148.826335,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 54816,
                        "time": 148.95677,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 54864,
                        "time": 149.08720499999998,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 54864,
                        "time": 149.08720499999998,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 54912,
                        "time": 149.21764,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 54960,
                        "time": 149.348075,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 54960,
                        "time": 149.348075,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 55008,
                        "time": 149.47851,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 55008,
                        "time": 149.47851,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 55056,
                        "time": 149.608945,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 55056,
                        "time": 149.608945,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 55056,
                        "time": 149.608945,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 55104,
                        "time": 149.73937999999998,
                        "velocity": 0.3858267716535433
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 55104,
                        "time": 149.73937999999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 55152,
                        "time": 149.869815,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 55152,
                        "time": 149.869815,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 40,
                        "name": "E2",
                        "ticks": 55200,
                        "time": 150.00025,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 55200,
                        "time": 150.00025,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 55200,
                        "time": 150.00025,
                        "velocity": 0.3858267716535433
                    }
                ],
                "endOfTrackTicks": 55248
            },
            {
                "channel": 0,
                "controlChanges": {
                    "6": [
                        {
                            "number": 6,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.09448818897637795
                        }
                    ],
                    "7": [
                        {
                            "number": 7,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.7874015748031497
                        }
                    ],
                    "10": [
                        {
                            "number": 10,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.4015748031496063
                        }
                    ],
                    "64": [
                        {
                            "number": 64,
                            "ticks": 0,
                            "time": 0,
                            "value": 0
                        }
                    ],
                    "91": [
                        {
                            "number": 91,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.3779527559055118
                        }
                    ],
                    "100": [
                        {
                            "number": 100,
                            "ticks": 0,
                            "time": 0,
                            "value": 0
                        }
                    ],
                    "101": [
                        {
                            "number": 101,
                            "ticks": 0,
                            "time": 0,
                            "value": 0
                        }
                    ]
                },
                "pitchBends": [
                    {
                        "ticks": 0,
                        "time": 0,
                        "value": 0
                    }
                ],
                "instrument": {
                    "family": "piano",
                    "number": 0,
                    "name": "acoustic_grand_piano"
                },
                "name": "",
                "notes": [
                    {
                        "duration": 0.130435,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 0,
                        "time": 0,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.130435,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 48,
                        "time": 0.130435,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26087,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 96,
                        "time": 0.26087,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.391305,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 192,
                        "time": 0.52174,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26087000000000005,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 336,
                        "time": 0.913045,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26086999999999994,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 432,
                        "time": 1.173915,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26086999999999994,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 528,
                        "time": 1.434785,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000008,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 624,
                        "time": 1.695655,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999986,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 672,
                        "time": 1.82609,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000008,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 720,
                        "time": 1.9565249999999998,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999986,
                        "durationTicks": 48,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 768,
                        "time": 2.08696,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 816,
                        "time": 2.217395,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608699999999997,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 864,
                        "time": 2.34783,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.391305,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 960,
                        "time": 2.6087,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26087000000000016,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 1104,
                        "time": 3.000005,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608699999999997,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 1200,
                        "time": 3.260875,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26087000000000016,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 1296,
                        "time": 3.5217449999999997,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999986,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 1392,
                        "time": 3.782615,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999986,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 1440,
                        "time": 3.9130499999999997,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 1488,
                        "time": 4.0434849999999996,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 59,
                        "name": "B3",
                        "ticks": 1536,
                        "time": 4.17392,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304349999999994,
                        "durationTicks": 48,
                        "midi": 59,
                        "name": "B3",
                        "ticks": 1584,
                        "time": 4.304355,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 1632,
                        "time": 4.43479,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.391305,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 1728,
                        "time": 4.69566,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608699999999997,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 1872,
                        "time": 5.086965,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608699999999997,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 1968,
                        "time": 5.347835,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 2064,
                        "time": 5.608705,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304349999999994,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 2160,
                        "time": 5.869575,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 2208,
                        "time": 6.00001,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 2256,
                        "time": 6.130445,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304349999999994,
                        "durationTicks": 48,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 2304,
                        "time": 6.26088,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 2352,
                        "time": 6.391315,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608699999999997,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 2400,
                        "time": 6.52175,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.391305,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 2496,
                        "time": 6.78262,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608699999999997,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 2640,
                        "time": 7.173925,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 2736,
                        "time": 7.434794999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608699999999997,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 2832,
                        "time": 7.695665,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304349999999994,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 2928,
                        "time": 7.956535,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 2976,
                        "time": 8.086969999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 3024,
                        "time": 8.217405,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 3072,
                        "time": 8.34784,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 3120,
                        "time": 8.478275,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608699999999988,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 3168,
                        "time": 8.60871,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.3913050000000009,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 3264,
                        "time": 8.86958,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608699999999988,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 3408,
                        "time": 9.260885,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 3504,
                        "time": 9.521754999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 3600,
                        "time": 9.782625,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 3696,
                        "time": 10.043495,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 3744,
                        "time": 10.17393,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 3792,
                        "time": 10.304364999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 3840,
                        "time": 10.4348,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 3888,
                        "time": 10.565235,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 3936,
                        "time": 10.69567,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.3913049999999991,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4032,
                        "time": 10.95654,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 4176,
                        "time": 11.347845,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608699999999988,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 4272,
                        "time": 11.608715,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 4368,
                        "time": 11.869584999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 4464,
                        "time": 12.130455,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 4512,
                        "time": 12.26089,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 4560,
                        "time": 12.391325,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 59,
                        "name": "B3",
                        "ticks": 4608,
                        "time": 12.52176,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 59,
                        "name": "B3",
                        "ticks": 4656,
                        "time": 12.652194999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 4704,
                        "time": 12.78263,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.3913049999999991,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 4800,
                        "time": 13.0435,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 4944,
                        "time": 13.434804999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 5040,
                        "time": 13.695675,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608699999999988,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 5136,
                        "time": 13.956545,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 5232,
                        "time": 14.217414999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 5280,
                        "time": 14.34785,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 5328,
                        "time": 14.478285,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 5376,
                        "time": 14.60872,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 5424,
                        "time": 14.739155,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 5472,
                        "time": 14.869589999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.3913050000000009,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 5568,
                        "time": 15.13046,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608699999999988,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 5712,
                        "time": 15.521765,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 5808,
                        "time": 15.782634999999999,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 5904,
                        "time": 16.043505,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 6000,
                        "time": 16.304375,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 6048,
                        "time": 16.43481,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 6096,
                        "time": 16.565245,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 6144,
                        "time": 16.69568,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 6192,
                        "time": 16.826114999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 86,
                        "name": "D6",
                        "ticks": 6240,
                        "time": 16.95655,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.3913049999999991,
                        "durationTicks": 144,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 6336,
                        "time": 17.21742,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 6480,
                        "time": 17.608725,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 6576,
                        "time": 17.869595,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 6672,
                        "time": 18.130465,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 6768,
                        "time": 18.391334999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 6816,
                        "time": 18.52177,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 6864,
                        "time": 18.652205,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 6912,
                        "time": 18.78264,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 6960,
                        "time": 18.913075,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 86,
                        "name": "D6",
                        "ticks": 7008,
                        "time": 19.043509999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.3913050000000027,
                        "durationTicks": 144,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 7104,
                        "time": 19.30438,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 7248,
                        "time": 19.695685,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 7344,
                        "time": 19.956554999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 7440,
                        "time": 20.217425,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 7536,
                        "time": 20.478295,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 7584,
                        "time": 20.608729999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 7632,
                        "time": 20.739165,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 71,
                        "name": "B4",
                        "ticks": 7680,
                        "time": 20.8696,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 71,
                        "name": "B4",
                        "ticks": 7728,
                        "time": 21.000035,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 86,
                        "name": "D6",
                        "ticks": 7776,
                        "time": 21.13047,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.3913049999999991,
                        "durationTicks": 144,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 7872,
                        "time": 21.39134,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 8016,
                        "time": 21.782645,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 8112,
                        "time": 22.043515,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 8208,
                        "time": 22.304385,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 8304,
                        "time": 22.565255,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 8352,
                        "time": 22.69569,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 8400,
                        "time": 22.826124999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 8448,
                        "time": 22.95656,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 8496,
                        "time": 23.086994999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 86,
                        "name": "D6",
                        "ticks": 8544,
                        "time": 23.21743,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.3913049999999991,
                        "durationTicks": 144,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 8640,
                        "time": 23.4783,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 8784,
                        "time": 23.869605,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 8880,
                        "time": 24.130475,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 8976,
                        "time": 24.391344999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 9072,
                        "time": 24.652214999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 9120,
                        "time": 24.78265,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 9168,
                        "time": 24.913085,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 9216,
                        "time": 25.04352,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 9264,
                        "time": 25.173955,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 86,
                        "name": "D6",
                        "ticks": 9312,
                        "time": 25.304389999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.3913049999999991,
                        "durationTicks": 144,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 9408,
                        "time": 25.56526,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 9552,
                        "time": 25.956564999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 9648,
                        "time": 26.217435,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 9744,
                        "time": 26.478305,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 9840,
                        "time": 26.739175,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 9888,
                        "time": 26.869609999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 9936,
                        "time": 27.000045,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 9984,
                        "time": 27.13048,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 10032,
                        "time": 27.260915,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 86,
                        "name": "D6",
                        "ticks": 10080,
                        "time": 27.39135,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.3913049999999991,
                        "durationTicks": 144,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 10176,
                        "time": 27.65222,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 10320,
                        "time": 28.043525,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 10416,
                        "time": 28.304395,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 10512,
                        "time": 28.565265,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 10608,
                        "time": 28.826135,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 10656,
                        "time": 28.95657,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 10704,
                        "time": 29.087004999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 71,
                        "name": "B4",
                        "ticks": 10752,
                        "time": 29.21744,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 71,
                        "name": "B4",
                        "ticks": 10800,
                        "time": 29.347875,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 86,
                        "name": "D6",
                        "ticks": 10848,
                        "time": 29.47831,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.3913050000000027,
                        "durationTicks": 144,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 10944,
                        "time": 29.739179999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 11088,
                        "time": 30.130485,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 11184,
                        "time": 30.391354999999997,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 11280,
                        "time": 30.652224999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 11376,
                        "time": 30.913095,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 11424,
                        "time": 31.04353,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 11472,
                        "time": 31.173965,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 11520,
                        "time": 31.304399999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 11568,
                        "time": 31.434835,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 86,
                        "name": "D6",
                        "ticks": 11616,
                        "time": 31.565269999999998,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.3913049999999991,
                        "durationTicks": 144,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 11712,
                        "time": 31.82614,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 11856,
                        "time": 32.217445,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 11952,
                        "time": 32.478315,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 12048,
                        "time": 32.739185,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 12144,
                        "time": 33.000054999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 12192,
                        "time": 33.13049,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 12240,
                        "time": 33.260925,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 12288,
                        "time": 33.39136,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 12384,
                        "time": 33.652229999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 12432,
                        "time": 33.782665,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 12528,
                        "time": 34.043535,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 12624,
                        "time": 34.304404999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 12720,
                        "time": 34.565275,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.6521749999999997,
                        "durationTicks": 240,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 12816,
                        "time": 34.826145,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 13056,
                        "time": 35.47832,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 13152,
                        "time": 35.73919,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 13200,
                        "time": 35.869625,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 13296,
                        "time": 36.130494999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 13392,
                        "time": 36.391365,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 13488,
                        "time": 36.652235,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 13536,
                        "time": 36.782669999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 13584,
                        "time": 36.913105,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 13632,
                        "time": 37.04354,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.3913050000000027,
                        "durationTicks": 144,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 13680,
                        "time": 37.173975,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 13824,
                        "time": 37.56528,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 13920,
                        "time": 37.82615,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 13968,
                        "time": 37.956585,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 14064,
                        "time": 38.217455,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 14160,
                        "time": 38.478325,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 14256,
                        "time": 38.739194999999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 84,
                        "name": "C6",
                        "ticks": 14352,
                        "time": 39.000065,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.3913050000000027,
                        "durationTicks": 144,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 14448,
                        "time": 39.260934999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 86,
                        "name": "D6",
                        "ticks": 14592,
                        "time": 39.65224,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 86,
                        "name": "D6",
                        "ticks": 14688,
                        "time": 39.913109999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 86,
                        "name": "D6",
                        "ticks": 14784,
                        "time": 40.17398,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 14832,
                        "time": 40.304415,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 86,
                        "name": "D6",
                        "ticks": 14880,
                        "time": 40.43485,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.173915000000001,
                        "durationTicks": 432,
                        "midi": 84,
                        "name": "C6",
                        "ticks": 14928,
                        "time": 40.565284999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 15360,
                        "time": 41.7392,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 15360,
                        "time": 41.7392,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 15456,
                        "time": 42.00007,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 15456,
                        "time": 42.00007,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 15504,
                        "time": 42.130505,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 15504,
                        "time": 42.130505,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 15600,
                        "time": 42.391375,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 15600,
                        "time": 42.391375,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 15696,
                        "time": 42.652245,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 15696,
                        "time": 42.652245,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 15792,
                        "time": 42.913115,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 15792,
                        "time": 42.913115,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.6521749999999997,
                        "durationTicks": 240,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 15888,
                        "time": 43.173985,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.6521749999999997,
                        "durationTicks": 240,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 15888,
                        "time": 43.173985,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 16128,
                        "time": 43.82616,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 16128,
                        "time": 43.82616,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 16224,
                        "time": 44.08703,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 16224,
                        "time": 44.08703,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 16272,
                        "time": 44.217465,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 16272,
                        "time": 44.217465,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 16368,
                        "time": 44.478335,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 16368,
                        "time": 44.478335,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 16464,
                        "time": 44.739205,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 16464,
                        "time": 44.739205,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 16560,
                        "time": 45.000074999999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 16560,
                        "time": 45.000074999999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 16656,
                        "time": 45.260945,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 86,
                        "name": "D6",
                        "ticks": 16656,
                        "time": 45.260945,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 16752,
                        "time": 45.521815,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 16752,
                        "time": 45.521815,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 16800,
                        "time": 45.652249999999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 16800,
                        "time": 45.652249999999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 86,
                        "name": "D6",
                        "ticks": 16896,
                        "time": 45.91312,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 16896,
                        "time": 45.91312,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 16992,
                        "time": 46.173989999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 16992,
                        "time": 46.173989999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 17088,
                        "time": 46.43486,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 17088,
                        "time": 46.43486,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 17184,
                        "time": 46.69573,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 17184,
                        "time": 46.69573,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 17280,
                        "time": 46.9566,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 84,
                        "name": "C6",
                        "ticks": 17280,
                        "time": 46.9566,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 17376,
                        "time": 47.21747,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 17376,
                        "time": 47.21747,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 17472,
                        "time": 47.478339999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 17472,
                        "time": 47.478339999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 17568,
                        "time": 47.73921,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 17568,
                        "time": 47.73921,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 17664,
                        "time": 48.00008,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 17760,
                        "time": 48.26095,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 17808,
                        "time": 48.391385,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 17904,
                        "time": 48.652255,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 17904,
                        "time": 48.652255,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.173915000000001,
                        "durationTicks": 432,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 18000,
                        "time": 48.913125,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.173915000000001,
                        "durationTicks": 432,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 18000,
                        "time": 48.913125,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.173915000000001,
                        "durationTicks": 432,
                        "midi": 84,
                        "name": "C6",
                        "ticks": 18000,
                        "time": 48.913125,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 18816,
                        "time": 51.13052,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 18864,
                        "time": 51.260954999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 18912,
                        "time": 51.39139,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 18960,
                        "time": 51.521825,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 19008,
                        "time": 51.65226,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 19056,
                        "time": 51.782695,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 19104,
                        "time": 51.913129999999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 19152,
                        "time": 52.043565,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.06521749999999571,
                        "durationTicks": 24,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 19200,
                        "time": 52.174,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.06521750000000281,
                        "durationTicks": 24,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 19224,
                        "time": 52.239217499999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.06521750000000281,
                        "durationTicks": 24,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 19248,
                        "time": 52.304435,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.06521749999999571,
                        "durationTicks": 24,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 19272,
                        "time": 52.3696525,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 19296,
                        "time": 52.43487,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.0434799999999953,
                        "durationTicks": 384,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 19392,
                        "time": 52.69574,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.0434799999999953,
                        "durationTicks": 384,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 19392,
                        "time": 52.69574,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 19824,
                        "time": 53.869655,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 19920,
                        "time": 54.130525,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 84,
                        "name": "C6",
                        "ticks": 19968,
                        "time": 54.26096,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 20064,
                        "time": 54.52183,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 20112,
                        "time": 54.652265,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 20160,
                        "time": 54.7827,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 20208,
                        "time": 54.913135,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 20256,
                        "time": 55.043569999999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 20304,
                        "time": 55.174005,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 20352,
                        "time": 55.30444,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 20448,
                        "time": 55.56531,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 20544,
                        "time": 55.82618,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 84,
                        "name": "C6",
                        "ticks": 20640,
                        "time": 56.08705,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 85,
                        "name": "C#6",
                        "ticks": 20736,
                        "time": 56.347919999999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 73,
                        "name": "C#5",
                        "ticks": 20736,
                        "time": 56.347919999999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 20832,
                        "time": 56.60879,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 20928,
                        "time": 56.869659999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 20976,
                        "time": 57.000094999999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 21024,
                        "time": 57.13053,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.173915000000001,
                        "durationTicks": 432,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 21072,
                        "time": 57.260965,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.173915000000001,
                        "durationTicks": 432,
                        "midi": 75,
                        "name": "D#5",
                        "ticks": 21072,
                        "time": 57.260965,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 21504,
                        "time": 58.43488,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 21600,
                        "time": 58.69575,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 21696,
                        "time": 58.95662,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 21696,
                        "time": 58.95662,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 21792,
                        "time": 59.21749,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000012,
                        "durationTicks": 192,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 21888,
                        "time": 59.478359999999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000012,
                        "durationTicks": 192,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 21888,
                        "time": 59.478359999999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000012,
                        "durationTicks": 192,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 22080,
                        "time": 60.000099999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000012,
                        "durationTicks": 192,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 22080,
                        "time": 60.000099999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000012,
                        "durationTicks": 192,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 22272,
                        "time": 60.52184,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000012,
                        "durationTicks": 192,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 22272,
                        "time": 60.52184,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000012,
                        "durationTicks": 192,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 22464,
                        "time": 61.04358,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000012,
                        "durationTicks": 192,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 22464,
                        "time": 61.04358,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000012,
                        "durationTicks": 192,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 22656,
                        "time": 61.56532,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000012,
                        "durationTicks": 192,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 22656,
                        "time": 61.56532,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217399999999941,
                        "durationTicks": 192,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 22848,
                        "time": 62.08706,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217399999999941,
                        "durationTicks": 192,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 22848,
                        "time": 62.08706,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.0434800000000024,
                        "durationTicks": 384,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 23040,
                        "time": 62.608799999999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.0434800000000024,
                        "durationTicks": 384,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 23040,
                        "time": 62.608799999999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 23424,
                        "time": 63.65228,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 23472,
                        "time": 63.782714999999996,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 23520,
                        "time": 63.913149999999995,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 78,
                        "name": "F#5",
                        "ticks": 23568,
                        "time": 64.043585,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 23616,
                        "time": 64.17402,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 23664,
                        "time": 64.304455,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 75,
                        "name": "D#5",
                        "ticks": 23712,
                        "time": 64.43489,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 23760,
                        "time": 64.565325,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.913045000000011,
                        "durationTicks": 336,
                        "midi": 73,
                        "name": "C#5",
                        "ticks": 23808,
                        "time": 64.69575999999999,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.913045000000011,
                        "durationTicks": 336,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 23808,
                        "time": 64.69575999999999,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.1739149999999938,
                        "durationTicks": 432,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 24144,
                        "time": 65.608805,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.1739149999999938,
                        "durationTicks": 432,
                        "midi": 75,
                        "name": "D#5",
                        "ticks": 24144,
                        "time": 65.608805,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 24960,
                        "time": 67.8262,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 25008,
                        "time": 67.95663499999999,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 25056,
                        "time": 68.08707,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 25104,
                        "time": 68.217505,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 25152,
                        "time": 68.34794,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 25200,
                        "time": 68.478375,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 25248,
                        "time": 68.60880999999999,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 25296,
                        "time": 68.739245,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.0652174999999886,
                        "durationTicks": 24,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 25344,
                        "time": 68.86968,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.06521750000000281,
                        "durationTicks": 24,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 25368,
                        "time": 68.93489749999999,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.06521750000000281,
                        "durationTicks": 24,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 25392,
                        "time": 69.000115,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.06521750000000281,
                        "durationTicks": 24,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 25416,
                        "time": 69.0653325,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 25440,
                        "time": 69.13055,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.0434800000000024,
                        "durationTicks": 384,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 25536,
                        "time": 69.39142,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.0434800000000024,
                        "durationTicks": 384,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 25536,
                        "time": 69.39142,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 25968,
                        "time": 70.565335,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 26064,
                        "time": 70.826205,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 84,
                        "name": "C6",
                        "ticks": 26112,
                        "time": 70.95664,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 26208,
                        "time": 71.21751,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 26256,
                        "time": 71.347945,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 26304,
                        "time": 71.47838,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 26352,
                        "time": 71.60881499999999,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 26400,
                        "time": 71.73925,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 26448,
                        "time": 71.869685,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 26496,
                        "time": 72.00012,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 26592,
                        "time": 72.26098999999999,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 26688,
                        "time": 72.52186,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 84,
                        "name": "C6",
                        "ticks": 26784,
                        "time": 72.78273,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 85,
                        "name": "C#6",
                        "ticks": 26880,
                        "time": 73.0436,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 73,
                        "name": "C#5",
                        "ticks": 26880,
                        "time": 73.0436,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 26976,
                        "time": 73.30447,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 27072,
                        "time": 73.56533999999999,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 27120,
                        "time": 73.695775,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 27168,
                        "time": 73.82621,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.173915000000008,
                        "durationTicks": 432,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 27216,
                        "time": 73.956645,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.173915000000008,
                        "durationTicks": 432,
                        "midi": 75,
                        "name": "D#5",
                        "ticks": 27216,
                        "time": 73.956645,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 27648,
                        "time": 75.13056,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 27744,
                        "time": 75.39143,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 27840,
                        "time": 75.6523,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 27840,
                        "time": 75.6523,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 27936,
                        "time": 75.91317,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000083,
                        "durationTicks": 192,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 28032,
                        "time": 76.17403999999999,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000083,
                        "durationTicks": 192,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 28032,
                        "time": 76.17403999999999,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217399999999941,
                        "durationTicks": 192,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 28224,
                        "time": 76.69578,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217399999999941,
                        "durationTicks": 192,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 28224,
                        "time": 76.69578,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000083,
                        "durationTicks": 192,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 28416,
                        "time": 77.21752,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000083,
                        "durationTicks": 192,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 28416,
                        "time": 77.21752,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217399999999941,
                        "durationTicks": 192,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 28608,
                        "time": 77.73926,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217399999999941,
                        "durationTicks": 192,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 28608,
                        "time": 77.73926,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000083,
                        "durationTicks": 192,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 28800,
                        "time": 78.261,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217400000000083,
                        "durationTicks": 192,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 28800,
                        "time": 78.261,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217399999999941,
                        "durationTicks": 192,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 28992,
                        "time": 78.78274,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.5217399999999941,
                        "durationTicks": 192,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 28992,
                        "time": 78.78274,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.0434800000000024,
                        "durationTicks": 384,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 29184,
                        "time": 79.30448,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.0434800000000024,
                        "durationTicks": 384,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 29184,
                        "time": 79.30448,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 81,
                        "name": "A5",
                        "ticks": 29568,
                        "time": 80.34796,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 80,
                        "name": "G#5",
                        "ticks": 29616,
                        "time": 80.47839499999999,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 79,
                        "name": "G5",
                        "ticks": 29664,
                        "time": 80.60883,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 78,
                        "name": "F#5",
                        "ticks": 29712,
                        "time": 80.739265,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 29760,
                        "time": 80.8697,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 29808,
                        "time": 81.000135,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 75,
                        "name": "D#5",
                        "ticks": 29856,
                        "time": 81.13056999999999,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 29904,
                        "time": 81.261005,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.9130449999999968,
                        "durationTicks": 336,
                        "midi": 73,
                        "name": "C#5",
                        "ticks": 29952,
                        "time": 81.39144,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 0.9130449999999968,
                        "durationTicks": 336,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 29952,
                        "time": 81.39144,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.1739149999999938,
                        "durationTicks": 432,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 30288,
                        "time": 82.304485,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.1739149999999938,
                        "durationTicks": 432,
                        "midi": 75,
                        "name": "D#5",
                        "ticks": 30288,
                        "time": 82.304485,
                        "velocity": 0.7244094488188977
                    },
                    {
                        "duration": 1.5652199999999965,
                        "durationTicks": 576,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 30720,
                        "time": 83.4784,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.5217400000000083,
                        "durationTicks": 192,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 31296,
                        "time": 85.04361999999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 1.0434800000000024,
                        "durationTicks": 384,
                        "midi": 64,
                        "name": "E4",
                        "ticks": 31488,
                        "time": 85.56536,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 1.0434800000000024,
                        "durationTicks": 384,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 31872,
                        "time": 86.60884,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 2.0869599999999906,
                        "durationTicks": 768,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 32256,
                        "time": 87.65232,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 1.5652199999999965,
                        "durationTicks": 576,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 33792,
                        "time": 91.82624,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.5217400000000083,
                        "durationTicks": 192,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 34368,
                        "time": 93.39146,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 1.0434799999999882,
                        "durationTicks": 384,
                        "midi": 64,
                        "name": "E4",
                        "ticks": 34560,
                        "time": 93.9132,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 1.0434800000000024,
                        "durationTicks": 384,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 34944,
                        "time": 94.95667999999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 2.086960000000005,
                        "durationTicks": 768,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 35328,
                        "time": 96.00016,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 36864,
                        "time": 100.17408,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 36912,
                        "time": 100.304515,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 36960,
                        "time": 100.43495,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.3913050000000027,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 37056,
                        "time": 100.69582,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 37200,
                        "time": 101.087125,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 37296,
                        "time": 101.347995,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 37392,
                        "time": 101.608865,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 37488,
                        "time": 101.86973499999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 37536,
                        "time": 102.00017,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 37584,
                        "time": 102.130605,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 37632,
                        "time": 102.26104,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 37680,
                        "time": 102.391475,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 37728,
                        "time": 102.52190999999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.39130499999998847,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 37824,
                        "time": 102.78278,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 37968,
                        "time": 103.17408499999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 38064,
                        "time": 103.434955,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 38160,
                        "time": 103.695825,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 38256,
                        "time": 103.956695,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 38304,
                        "time": 104.08713,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 38352,
                        "time": 104.217565,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 59,
                        "name": "B3",
                        "ticks": 38400,
                        "time": 104.348,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 59,
                        "name": "B3",
                        "ticks": 38448,
                        "time": 104.47843499999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 38496,
                        "time": 104.60887,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.3913050000000027,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 38592,
                        "time": 104.86974,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 38736,
                        "time": 105.261045,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 38832,
                        "time": 105.52191499999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 38928,
                        "time": 105.78278499999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 39024,
                        "time": 106.043655,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 39072,
                        "time": 106.17408999999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 39120,
                        "time": 106.304525,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 59,
                        "name": "B3",
                        "ticks": 39168,
                        "time": 106.43495999999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 59,
                        "name": "B3",
                        "ticks": 39216,
                        "time": 106.565395,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 39264,
                        "time": 106.69583,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.3913050000000027,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 39360,
                        "time": 106.9567,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 39504,
                        "time": 107.348005,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 39600,
                        "time": 107.608875,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 39696,
                        "time": 107.869745,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 39792,
                        "time": 108.13061499999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 39840,
                        "time": 108.26105,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 39888,
                        "time": 108.391485,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 39936,
                        "time": 108.52192,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 39984,
                        "time": 108.652355,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 40032,
                        "time": 108.78278999999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.39130499999998847,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 40128,
                        "time": 109.04366,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 40272,
                        "time": 109.43496499999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 40368,
                        "time": 109.695835,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 40464,
                        "time": 109.956705,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 40560,
                        "time": 110.217575,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 40608,
                        "time": 110.34801,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 40656,
                        "time": 110.478445,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 40704,
                        "time": 110.60888,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 40752,
                        "time": 110.73931499999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 40800,
                        "time": 110.86975,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.3913050000000027,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 40896,
                        "time": 111.13062,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 41040,
                        "time": 111.521925,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 41136,
                        "time": 111.782795,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 41232,
                        "time": 112.04366499999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 41328,
                        "time": 112.304535,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 41376,
                        "time": 112.43496999999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 41424,
                        "time": 112.565405,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.19565249999999423,
                        "durationTicks": 72,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 41568,
                        "time": 112.95671,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 41568,
                        "time": 112.95671,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 41664,
                        "time": 113.21758,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 41664,
                        "time": 113.21758,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 41808,
                        "time": 113.608885,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 41808,
                        "time": 113.608885,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 41904,
                        "time": 113.869755,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 41904,
                        "time": 113.869755,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 42000,
                        "time": 114.130625,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 42000,
                        "time": 114.130625,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 42096,
                        "time": 114.39149499999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 42096,
                        "time": 114.39149499999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 64,
                        "name": "E4",
                        "ticks": 42144,
                        "time": 114.52193,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 42144,
                        "time": 114.52193,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 42192,
                        "time": 114.65236499999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 42192,
                        "time": 114.65236499999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.19565250000000844,
                        "durationTicks": 72,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 42336,
                        "time": 115.04366999999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 77,
                        "name": "F5",
                        "ticks": 42336,
                        "time": 115.04366999999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 42432,
                        "time": 115.30454,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 42432,
                        "time": 115.30454,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 42576,
                        "time": 115.69584499999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 42576,
                        "time": 115.69584499999999,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 76,
                        "name": "E5",
                        "ticks": 42672,
                        "time": 115.956715,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 42672,
                        "time": 115.956715,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 42768,
                        "time": 116.217585,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 42768,
                        "time": 116.217585,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 42864,
                        "time": 116.478455,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 42864,
                        "time": 116.478455,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 64,
                        "name": "E4",
                        "ticks": 42912,
                        "time": 116.60889,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 42912,
                        "time": 116.60889,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 42960,
                        "time": 116.739325,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 42960,
                        "time": 116.739325,
                        "velocity": 0.8188976377952756
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 43008,
                        "time": 116.86976,
                        "velocity": 0.6692913385826772
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 43008,
                        "time": 116.86976,
                        "velocity": 0.6692913385826772
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 43104,
                        "time": 117.13063,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 43104,
                        "time": 117.13063,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 43200,
                        "time": 117.3915,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 43200,
                        "time": 117.3915,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 43248,
                        "time": 117.521935,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 43248,
                        "time": 117.521935,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 43344,
                        "time": 117.782805,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 43344,
                        "time": 117.782805,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 43440,
                        "time": 118.043675,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 43440,
                        "time": 118.043675,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 43536,
                        "time": 118.30454499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 43536,
                        "time": 118.30454499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 43632,
                        "time": 118.565415,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 43632,
                        "time": 118.565415,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 43680,
                        "time": 118.69585,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 43680,
                        "time": 118.69585,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 43776,
                        "time": 118.95671999999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 43776,
                        "time": 118.95671999999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 43872,
                        "time": 119.21759,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 43872,
                        "time": 119.21759,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 43968,
                        "time": 119.47846,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 43968,
                        "time": 119.47846,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 44016,
                        "time": 119.60889499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 44016,
                        "time": 119.60889499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 44112,
                        "time": 119.869765,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 44112,
                        "time": 119.869765,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 44208,
                        "time": 120.130635,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 44208,
                        "time": 120.130635,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 44304,
                        "time": 120.391505,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 44304,
                        "time": 120.391505,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 44400,
                        "time": 120.65237499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 44400,
                        "time": 120.65237499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 44448,
                        "time": 120.78281,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 44448,
                        "time": 120.78281,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 44544,
                        "time": 121.04368,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 44544,
                        "time": 121.04368,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 44640,
                        "time": 121.30454999999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 44640,
                        "time": 121.30454999999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 44736,
                        "time": 121.56541999999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 44736,
                        "time": 121.56541999999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 44784,
                        "time": 121.695855,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 44784,
                        "time": 121.695855,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 44880,
                        "time": 121.95672499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 73,
                        "name": "C#5",
                        "ticks": 44880,
                        "time": 121.95672499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 73,
                        "name": "C#5",
                        "ticks": 44976,
                        "time": 122.21759499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 44976,
                        "time": 122.21759499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 45072,
                        "time": 122.478465,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 73,
                        "name": "C#5",
                        "ticks": 45072,
                        "time": 122.478465,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 73,
                        "name": "C#5",
                        "ticks": 45168,
                        "time": 122.739335,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 45168,
                        "time": 122.739335,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 45216,
                        "time": 122.86977,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 73,
                        "name": "C#5",
                        "ticks": 45216,
                        "time": 122.86977,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 45312,
                        "time": 123.13064,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 45312,
                        "time": 123.13064,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 45408,
                        "time": 123.39151,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 45408,
                        "time": 123.39151,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 45504,
                        "time": 123.65238,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 45504,
                        "time": 123.65238,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 45552,
                        "time": 123.782815,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 45552,
                        "time": 123.782815,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 45648,
                        "time": 124.043685,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 71,
                        "name": "B4",
                        "ticks": 45648,
                        "time": 124.043685,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 71,
                        "name": "B4",
                        "ticks": 45744,
                        "time": 124.304555,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 45744,
                        "time": 124.304555,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 45840,
                        "time": 124.56542499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 71,
                        "name": "B4",
                        "ticks": 45840,
                        "time": 124.56542499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 71,
                        "name": "B4",
                        "ticks": 45936,
                        "time": 124.826295,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 45936,
                        "time": 124.826295,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 45984,
                        "time": 124.95673,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 71,
                        "name": "B4",
                        "ticks": 45984,
                        "time": 124.95673,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 46080,
                        "time": 125.21759999999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 46080,
                        "time": 125.21759999999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 46176,
                        "time": 125.47847,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 46176,
                        "time": 125.47847,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 46272,
                        "time": 125.73934,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 46272,
                        "time": 125.73934,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 46320,
                        "time": 125.86977499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 46320,
                        "time": 125.86977499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 46416,
                        "time": 126.130645,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 46416,
                        "time": 126.130645,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 46512,
                        "time": 126.391515,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 46512,
                        "time": 126.391515,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 46608,
                        "time": 126.652385,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 46608,
                        "time": 126.652385,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 46704,
                        "time": 126.91325499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 46704,
                        "time": 126.91325499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 46752,
                        "time": 127.04369,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 46752,
                        "time": 127.04369,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 46848,
                        "time": 127.30456,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 46848,
                        "time": 127.30456,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 46944,
                        "time": 127.56542999999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 46944,
                        "time": 127.56542999999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 47040,
                        "time": 127.82629999999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 47040,
                        "time": 127.82629999999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 47088,
                        "time": 127.956735,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 47088,
                        "time": 127.956735,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 47184,
                        "time": 128.217605,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 47184,
                        "time": 128.217605,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 47280,
                        "time": 128.478475,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 47280,
                        "time": 128.478475,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 47376,
                        "time": 128.739345,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 47376,
                        "time": 128.739345,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 47472,
                        "time": 129.000215,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 47472,
                        "time": 129.000215,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 47520,
                        "time": 129.13065,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 47520,
                        "time": 129.13065,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 47616,
                        "time": 129.39151999999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 47616,
                        "time": 129.39151999999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 47712,
                        "time": 129.65239,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 47712,
                        "time": 129.65239,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 47808,
                        "time": 129.91326,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 47808,
                        "time": 129.91326,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 47856,
                        "time": 130.04369499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 47856,
                        "time": 130.04369499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 47952,
                        "time": 130.304565,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 47952,
                        "time": 130.304565,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 48048,
                        "time": 130.565435,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 48048,
                        "time": 130.565435,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 48144,
                        "time": 130.826305,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 48144,
                        "time": 130.826305,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 48240,
                        "time": 131.087175,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 48240,
                        "time": 131.087175,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 48288,
                        "time": 131.21761,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 48288,
                        "time": 131.21761,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 48384,
                        "time": 131.47848,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 48384,
                        "time": 131.47848,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 48480,
                        "time": 131.73935,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 48480,
                        "time": 131.73935,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 48576,
                        "time": 132.00021999999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 48576,
                        "time": 132.00021999999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 48624,
                        "time": 132.130655,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 48624,
                        "time": 132.130655,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 48720,
                        "time": 132.391525,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 48720,
                        "time": 132.391525,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 48816,
                        "time": 132.65239499999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 48816,
                        "time": 132.65239499999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 48912,
                        "time": 132.913265,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 48912,
                        "time": 132.913265,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 49008,
                        "time": 133.174135,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 49008,
                        "time": 133.174135,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 49056,
                        "time": 133.30456999999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 49056,
                        "time": 133.30456999999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 49152,
                        "time": 133.56544,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 49152,
                        "time": 133.56544,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 49248,
                        "time": 133.82631,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 49248,
                        "time": 133.82631,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 49344,
                        "time": 134.08718,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 49344,
                        "time": 134.08718,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 49392,
                        "time": 134.217615,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 49392,
                        "time": 134.217615,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 49488,
                        "time": 134.478485,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 49488,
                        "time": 134.478485,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 49584,
                        "time": 134.739355,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 49584,
                        "time": 134.739355,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 49680,
                        "time": 135.000225,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 49680,
                        "time": 135.000225,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 49776,
                        "time": 135.26109499999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 49776,
                        "time": 135.26109499999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 49824,
                        "time": 135.39153,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 49824,
                        "time": 135.39153,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 49920,
                        "time": 135.6524,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 49920,
                        "time": 135.6524,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 50016,
                        "time": 135.91326999999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 50016,
                        "time": 135.91326999999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 50112,
                        "time": 136.17414,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 50112,
                        "time": 136.17414,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 50160,
                        "time": 136.304575,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 50160,
                        "time": 136.304575,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 50256,
                        "time": 136.56544499999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 50256,
                        "time": 136.56544499999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 50352,
                        "time": 136.826315,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 50352,
                        "time": 136.826315,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 50448,
                        "time": 137.087185,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 50448,
                        "time": 137.087185,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 50544,
                        "time": 137.348055,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 50544,
                        "time": 137.348055,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 50592,
                        "time": 137.47849,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 50592,
                        "time": 137.47849,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 50688,
                        "time": 137.73936,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 50688,
                        "time": 137.73936,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 50784,
                        "time": 138.00023,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 50784,
                        "time": 138.00023,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 50880,
                        "time": 138.2611,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 50880,
                        "time": 138.2611,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 50928,
                        "time": 138.391535,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 50928,
                        "time": 138.391535,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 51024,
                        "time": 138.652405,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 73,
                        "name": "C#5",
                        "ticks": 51024,
                        "time": 138.652405,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 73,
                        "name": "C#5",
                        "ticks": 51120,
                        "time": 138.913275,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 51120,
                        "time": 138.913275,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 51216,
                        "time": 139.17414499999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 73,
                        "name": "C#5",
                        "ticks": 51216,
                        "time": 139.17414499999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 73,
                        "name": "C#5",
                        "ticks": 51312,
                        "time": 139.435015,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 51312,
                        "time": 139.435015,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 51360,
                        "time": 139.56545,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 73,
                        "name": "C#5",
                        "ticks": 51360,
                        "time": 139.56545,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 51456,
                        "time": 139.82631999999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 51456,
                        "time": 139.82631999999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 51552,
                        "time": 140.08719,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 51552,
                        "time": 140.08719,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 51648,
                        "time": 140.34806,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 51648,
                        "time": 140.34806,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 51696,
                        "time": 140.47849499999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 51696,
                        "time": 140.47849499999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 51792,
                        "time": 140.739365,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 71,
                        "name": "B4",
                        "ticks": 51792,
                        "time": 140.739365,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 71,
                        "name": "B4",
                        "ticks": 51888,
                        "time": 141.000235,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 51888,
                        "time": 141.000235,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 51984,
                        "time": 141.261105,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 71,
                        "name": "B4",
                        "ticks": 51984,
                        "time": 141.261105,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 71,
                        "name": "B4",
                        "ticks": 52080,
                        "time": 141.521975,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 52080,
                        "time": 141.521975,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 52128,
                        "time": 141.65241,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 71,
                        "name": "B4",
                        "ticks": 52128,
                        "time": 141.65241,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 52224,
                        "time": 141.91328,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 52224,
                        "time": 141.91328,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 52320,
                        "time": 142.17415,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 52320,
                        "time": 142.17415,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 52416,
                        "time": 142.43502,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 52416,
                        "time": 142.43502,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 52464,
                        "time": 142.565455,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 52464,
                        "time": 142.565455,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 52560,
                        "time": 142.826325,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 52560,
                        "time": 142.826325,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 52656,
                        "time": 143.087195,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 52656,
                        "time": 143.087195,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 52752,
                        "time": 143.348065,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 52752,
                        "time": 143.348065,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 52848,
                        "time": 143.608935,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 52848,
                        "time": 143.608935,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 52896,
                        "time": 143.73937,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 70,
                        "name": "A#4",
                        "ticks": 52896,
                        "time": 143.73937,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 52992,
                        "time": 144.00024,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 52992,
                        "time": 144.00024,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 53088,
                        "time": 144.26111,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 53088,
                        "time": 144.26111,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 53184,
                        "time": 144.52197999999999,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 53184,
                        "time": 144.52197999999999,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 53232,
                        "time": 144.652415,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 53232,
                        "time": 144.652415,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 53328,
                        "time": 144.913285,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 53328,
                        "time": 144.913285,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 53424,
                        "time": 145.17415499999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 53424,
                        "time": 145.17415499999998,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 53520,
                        "time": 145.435025,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 53520,
                        "time": 145.435025,
                        "velocity": 0.6771653543307087
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 53616,
                        "time": 145.695895,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 53616,
                        "time": 145.695895,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 53664,
                        "time": 145.82632999999998,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 72,
                        "name": "C5",
                        "ticks": 53664,
                        "time": 145.82632999999998,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 53760,
                        "time": 146.0872,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 53808,
                        "time": 146.217635,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 53856,
                        "time": 146.34807,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.3913050000000169,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 53952,
                        "time": 146.60894,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 54096,
                        "time": 147.000245,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 54192,
                        "time": 147.261115,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 54288,
                        "time": 147.521985,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 54384,
                        "time": 147.78285499999998,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 54432,
                        "time": 147.91329,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 54480,
                        "time": 148.043725,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 54528,
                        "time": 148.17416,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 54576,
                        "time": 148.304595,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 54624,
                        "time": 148.43502999999998,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.39130499999998847,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 54720,
                        "time": 148.6959,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 54864,
                        "time": 149.08720499999998,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 54960,
                        "time": 149.348075,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 55056,
                        "time": 149.608945,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 55152,
                        "time": 149.869815,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 55200,
                        "time": 150.00025,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 55248,
                        "time": 150.130685,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 55296,
                        "time": 150.26112,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 55344,
                        "time": 150.39155499999998,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 55392,
                        "time": 150.52199,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.39130499999998847,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 55488,
                        "time": 150.78286,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 55632,
                        "time": 151.174165,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 55728,
                        "time": 151.435035,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 55824,
                        "time": 151.69590499999998,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 55920,
                        "time": 151.956775,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 55968,
                        "time": 152.08721,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 56016,
                        "time": 152.217645,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 56064,
                        "time": 152.34807999999998,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 60,
                        "name": "C4",
                        "ticks": 56112,
                        "time": 152.478515,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 56160,
                        "time": 152.60895,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.39130499999998847,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 56256,
                        "time": 152.86982,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 56400,
                        "time": 153.261125,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 56496,
                        "time": 153.521995,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 56592,
                        "time": 153.782865,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 56688,
                        "time": 154.043735,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 56736,
                        "time": 154.17417,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 56784,
                        "time": 154.30460499999998,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 56832,
                        "time": 154.43504,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 56880,
                        "time": 154.565475,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 56928,
                        "time": 154.69591,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.3913050000000169,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 57024,
                        "time": 154.95677999999998,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 57168,
                        "time": 155.348085,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 57264,
                        "time": 155.60895499999998,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 57360,
                        "time": 155.869825,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 57456,
                        "time": 156.130695,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 57504,
                        "time": 156.26113,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 57552,
                        "time": 156.39156499999999,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 57600,
                        "time": 156.522,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 57648,
                        "time": 156.652435,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 74,
                        "name": "D5",
                        "ticks": 57696,
                        "time": 156.78287,
                        "velocity": 0.6850393700787402
                    },
                    {
                        "duration": 0.3913050000000169,
                        "durationTicks": 144,
                        "midi": 69,
                        "name": "A4",
                        "ticks": 57792,
                        "time": 157.04373999999999,
                        "velocity": 0.6929133858267716
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 68,
                        "name": "G#4",
                        "ticks": 57936,
                        "time": 157.435045,
                        "velocity": 0.6929133858267716
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 58032,
                        "time": 157.69591499999999,
                        "velocity": 0.6929133858267716
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 58128,
                        "time": 157.956785,
                        "velocity": 0.6929133858267716
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 58224,
                        "time": 158.217655,
                        "velocity": 0.6929133858267716
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 65,
                        "name": "F4",
                        "ticks": 58272,
                        "time": 158.34808999999998,
                        "velocity": 0.6929133858267716
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 67,
                        "name": "G4",
                        "ticks": 58320,
                        "time": 158.478525,
                        "velocity": 0.6929133858267716
                    }
                ],
                "endOfTrackTicks": 58368
            },
            {
                "channel": 1,
                "controlChanges": {
                    "6": [
                        {
                            "number": 6,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.09448818897637795
                        }
                    ],
                    "7": [
                        {
                            "number": 7,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.7874015748031497
                        }
                    ],
                    "10": [
                        {
                            "number": 10,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.4015748031496063
                        }
                    ],
                    "64": [
                        {
                            "number": 64,
                            "ticks": 0,
                            "time": 0,
                            "value": 0
                        }
                    ],
                    "91": [
                        {
                            "number": 91,
                            "ticks": 0,
                            "time": 0,
                            "value": 0.3779527559055118
                        }
                    ],
                    "100": [
                        {
                            "number": 100,
                            "ticks": 0,
                            "time": 0,
                            "value": 0
                        }
                    ],
                    "101": [
                        {
                            "number": 101,
                            "ticks": 0,
                            "time": 0,
                            "value": 0
                        }
                    ]
                },
                "pitchBends": [
                    {
                        "ticks": 0,
                        "time": 0,
                        "value": 0
                    }
                ],
                "instrument": {
                    "family": "piano",
                    "number": 0,
                    "name": "acoustic_grand_piano"
                },
                "name": "",
                "notes": [
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 3072,
                        "time": 8.34784,
                        "velocity": 0.5433070866141733
                    },
                    {
                        "duration": 0.2608699999999988,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 3168,
                        "time": 8.60871,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 3264,
                        "time": 8.86958,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 3312,
                        "time": 9.000015,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608699999999988,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 3408,
                        "time": 9.260885,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 3504,
                        "time": 9.521754999999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 3600,
                        "time": 9.782625,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 3696,
                        "time": 10.043495,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608699999999988,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 3744,
                        "time": 10.17393,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 3840,
                        "time": 10.4348,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 3936,
                        "time": 10.69567,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 4032,
                        "time": 10.95654,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 4080,
                        "time": 11.086974999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 4176,
                        "time": 11.347845,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.2608699999999988,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 4272,
                        "time": 11.608715,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 4368,
                        "time": 11.869584999999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 4464,
                        "time": 12.130455,
                        "velocity": 0.5511811023622047
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 4512,
                        "time": 12.26089,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608699999999988,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 4608,
                        "time": 12.52176,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 4704,
                        "time": 12.78263,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 4800,
                        "time": 13.0435,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608699999999988,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 4848,
                        "time": 13.173935,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 4944,
                        "time": 13.434804999999999,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 5040,
                        "time": 13.695675,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608699999999988,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 5136,
                        "time": 13.956545,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 5232,
                        "time": 14.217414999999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 5280,
                        "time": 14.34785,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608699999999988,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 5376,
                        "time": 14.60872,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 5472,
                        "time": 14.869589999999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.1304350000000003,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 5568,
                        "time": 15.13046,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 5616,
                        "time": 15.260895,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.2608699999999988,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 5712,
                        "time": 15.521765,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 5808,
                        "time": 15.782634999999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 5904,
                        "time": 16.043505,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 6000,
                        "time": 16.304375,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 6048,
                        "time": 16.43481,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 6144,
                        "time": 16.69568,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 6144,
                        "time": 16.69568,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 6240,
                        "time": 16.95655,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 6240,
                        "time": 16.95655,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 6336,
                        "time": 17.21742,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 6336,
                        "time": 17.21742,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 6384,
                        "time": 17.347855,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 6384,
                        "time": 17.347855,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 6480,
                        "time": 17.608725,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 6480,
                        "time": 17.608725,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 6576,
                        "time": 17.869595,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 6576,
                        "time": 17.869595,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 6672,
                        "time": 18.130465,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 6672,
                        "time": 18.130465,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 6768,
                        "time": 18.391334999999998,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 6768,
                        "time": 18.391334999999998,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 6816,
                        "time": 18.52177,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 6816,
                        "time": 18.52177,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 6912,
                        "time": 18.78264,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 6912,
                        "time": 18.78264,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 7008,
                        "time": 19.043509999999998,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7008,
                        "time": 19.043509999999998,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 7104,
                        "time": 19.30438,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7104,
                        "time": 19.30438,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7152,
                        "time": 19.434815,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 7152,
                        "time": 19.434815,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 7248,
                        "time": 19.695685,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7248,
                        "time": 19.695685,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7344,
                        "time": 19.956554999999998,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 7344,
                        "time": 19.956554999999998,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 7440,
                        "time": 20.217425,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7440,
                        "time": 20.217425,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7536,
                        "time": 20.478295,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 7536,
                        "time": 20.478295,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 7584,
                        "time": 20.608729999999998,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 7584,
                        "time": 20.608729999999998,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 7680,
                        "time": 20.8696,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 7680,
                        "time": 20.8696,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 7776,
                        "time": 21.13047,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 7776,
                        "time": 21.13047,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 7872,
                        "time": 21.39134,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 7872,
                        "time": 21.39134,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 7920,
                        "time": 21.521774999999998,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 7920,
                        "time": 21.521774999999998,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 8016,
                        "time": 21.782645,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 8016,
                        "time": 21.782645,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 8112,
                        "time": 22.043515,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 8112,
                        "time": 22.043515,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 8208,
                        "time": 22.304385,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 8208,
                        "time": 22.304385,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 8304,
                        "time": 22.565255,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 8304,
                        "time": 22.565255,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 8352,
                        "time": 22.69569,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 8352,
                        "time": 22.69569,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 34,
                        "name": "A#1",
                        "ticks": 8448,
                        "time": 22.95656,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8448,
                        "time": 22.95656,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 34,
                        "name": "A#1",
                        "ticks": 8544,
                        "time": 23.21743,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8544,
                        "time": 23.21743,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 34,
                        "name": "A#1",
                        "ticks": 8640,
                        "time": 23.4783,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8640,
                        "time": 23.4783,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 34,
                        "name": "A#1",
                        "ticks": 8688,
                        "time": 23.608735,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 8688,
                        "time": 23.608735,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 8784,
                        "time": 23.869605,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 8784,
                        "time": 23.869605,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 8880,
                        "time": 24.130475,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 8880,
                        "time": 24.130475,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 8976,
                        "time": 24.391344999999998,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 8976,
                        "time": 24.391344999999998,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 9072,
                        "time": 24.652214999999998,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 9072,
                        "time": 24.652214999999998,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 9120,
                        "time": 24.78265,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 9120,
                        "time": 24.78265,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 9216,
                        "time": 25.04352,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 9216,
                        "time": 25.04352,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 9312,
                        "time": 25.304389999999998,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 9312,
                        "time": 25.304389999999998,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 9408,
                        "time": 25.56526,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 9408,
                        "time": 25.56526,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 9456,
                        "time": 25.695695,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 9456,
                        "time": 25.695695,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 9552,
                        "time": 25.956564999999998,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 9552,
                        "time": 25.956564999999998,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 9648,
                        "time": 26.217435,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 9648,
                        "time": 26.217435,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 9744,
                        "time": 26.478305,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 9744,
                        "time": 26.478305,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 9840,
                        "time": 26.739175,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 9840,
                        "time": 26.739175,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 38,
                        "name": "D2",
                        "ticks": 9888,
                        "time": 26.869609999999998,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 9888,
                        "time": 26.869609999999998,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 9984,
                        "time": 27.13048,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 9984,
                        "time": 27.13048,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10080,
                        "time": 27.39135,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 10080,
                        "time": 27.39135,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10176,
                        "time": 27.65222,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 10176,
                        "time": 27.65222,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10224,
                        "time": 27.782655,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 10224,
                        "time": 27.782655,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10320,
                        "time": 28.043525,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 10320,
                        "time": 28.043525,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10416,
                        "time": 28.304395,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 10416,
                        "time": 28.304395,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10512,
                        "time": 28.565265,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 10512,
                        "time": 28.565265,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10608,
                        "time": 28.826135,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 10608,
                        "time": 28.826135,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 10656,
                        "time": 28.95657,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 10656,
                        "time": 28.95657,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 10752,
                        "time": 29.21744,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 10752,
                        "time": 29.21744,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 10848,
                        "time": 29.47831,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 10848,
                        "time": 29.47831,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 10944,
                        "time": 29.739179999999998,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 10944,
                        "time": 29.739179999999998,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 10992,
                        "time": 29.869615,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 10992,
                        "time": 29.869615,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 11088,
                        "time": 30.130485,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 11088,
                        "time": 30.130485,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 11184,
                        "time": 30.391354999999997,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 11184,
                        "time": 30.391354999999997,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 11280,
                        "time": 30.652224999999998,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 11280,
                        "time": 30.652224999999998,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 11376,
                        "time": 30.913095,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043500000000208,
                        "durationTicks": 48,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 11376,
                        "time": 30.913095,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 35,
                        "name": "B1",
                        "ticks": 11424,
                        "time": 31.04353,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 11424,
                        "time": 31.04353,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 34,
                        "name": "A#1",
                        "ticks": 11520,
                        "time": 31.304399999999998,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11520,
                        "time": 31.304399999999998,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 34,
                        "name": "A#1",
                        "ticks": 11616,
                        "time": 31.565269999999998,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11616,
                        "time": 31.565269999999998,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 34,
                        "name": "A#1",
                        "ticks": 11712,
                        "time": 31.82614,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11712,
                        "time": 31.82614,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 11760,
                        "time": 31.956574999999997,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.2608700000000006,
                        "durationTicks": 96,
                        "midi": 34,
                        "name": "A#1",
                        "ticks": 11760,
                        "time": 31.956574999999997,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 11856,
                        "time": 32.217445,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 11856,
                        "time": 32.217445,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 11952,
                        "time": 32.478315,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 11952,
                        "time": 32.478315,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 12048,
                        "time": 32.739185,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 12048,
                        "time": 32.739185,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 12144,
                        "time": 33.000054999999996,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 12144,
                        "time": 33.000054999999996,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 36,
                        "name": "C2",
                        "ticks": 12192,
                        "time": 33.13049,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 12192,
                        "time": 33.13049,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 12288,
                        "time": 33.39136,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 12288,
                        "time": 33.39136,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 12384,
                        "time": 33.652229999999996,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 12384,
                        "time": 33.652229999999996,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 12480,
                        "time": 33.9131,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 12480,
                        "time": 33.9131,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 12528,
                        "time": 34.043535,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 12528,
                        "time": 34.043535,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 12624,
                        "time": 34.304404999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 12624,
                        "time": 34.304404999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 12720,
                        "time": 34.565275,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 12720,
                        "time": 34.565275,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 12816,
                        "time": 34.826145,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 12816,
                        "time": 34.826145,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 12912,
                        "time": 35.087015,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 12912,
                        "time": 35.087015,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 12960,
                        "time": 35.21745,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 12960,
                        "time": 35.21745,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 13056,
                        "time": 35.47832,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 13056,
                        "time": 35.47832,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 13152,
                        "time": 35.73919,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 13152,
                        "time": 35.73919,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 13248,
                        "time": 36.00006,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 13248,
                        "time": 36.00006,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 13296,
                        "time": 36.130494999999996,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 13296,
                        "time": 36.130494999999996,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 13392,
                        "time": 36.391365,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 13392,
                        "time": 36.391365,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 13488,
                        "time": 36.652235,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 13488,
                        "time": 36.652235,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 13584,
                        "time": 36.913105,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 13584,
                        "time": 36.913105,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 13680,
                        "time": 37.173975,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 13680,
                        "time": 37.173975,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 13728,
                        "time": 37.30441,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 13728,
                        "time": 37.30441,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 13824,
                        "time": 37.56528,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 13824,
                        "time": 37.56528,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 13920,
                        "time": 37.82615,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 13920,
                        "time": 37.82615,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 14016,
                        "time": 38.087019999999995,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 14016,
                        "time": 38.087019999999995,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 14064,
                        "time": 38.217455,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 14064,
                        "time": 38.217455,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 14160,
                        "time": 38.478325,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 14160,
                        "time": 38.478325,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 14256,
                        "time": 38.739194999999995,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 14256,
                        "time": 38.739194999999995,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 14352,
                        "time": 39.000065,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 14352,
                        "time": 39.000065,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 14448,
                        "time": 39.260934999999996,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 14448,
                        "time": 39.260934999999996,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 14496,
                        "time": 39.39137,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 14496,
                        "time": 39.39137,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 14592,
                        "time": 39.65224,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 14592,
                        "time": 39.65224,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 14688,
                        "time": 39.913109999999996,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 14688,
                        "time": 39.913109999999996,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 14784,
                        "time": 40.17398,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 14784,
                        "time": 40.17398,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 14832,
                        "time": 40.304415,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 14832,
                        "time": 40.304415,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 14928,
                        "time": 40.565284999999996,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 14928,
                        "time": 40.565284999999996,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 15024,
                        "time": 40.826155,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 15024,
                        "time": 40.826155,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 15120,
                        "time": 41.087025,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 15120,
                        "time": 41.087025,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 15216,
                        "time": 41.347895,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 15216,
                        "time": 41.347895,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 15264,
                        "time": 41.47833,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 15264,
                        "time": 41.47833,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 15360,
                        "time": 41.7392,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 15360,
                        "time": 41.7392,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 15456,
                        "time": 42.00007,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 15456,
                        "time": 42.00007,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 15552,
                        "time": 42.26094,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 15552,
                        "time": 42.26094,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 15600,
                        "time": 42.391375,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 15600,
                        "time": 42.391375,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 15696,
                        "time": 42.652245,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 15696,
                        "time": 42.652245,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 15792,
                        "time": 42.913115,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 15792,
                        "time": 42.913115,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 15888,
                        "time": 43.173985,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 15888,
                        "time": 43.173985,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 15984,
                        "time": 43.434855,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 15984,
                        "time": 43.434855,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 16032,
                        "time": 43.56529,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 16032,
                        "time": 43.56529,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 16128,
                        "time": 43.82616,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 16128,
                        "time": 43.82616,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 16224,
                        "time": 44.08703,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 16224,
                        "time": 44.08703,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 16320,
                        "time": 44.347899999999996,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 16320,
                        "time": 44.347899999999996,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 16368,
                        "time": 44.478335,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 16368,
                        "time": 44.478335,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 16464,
                        "time": 44.739205,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 16464,
                        "time": 44.739205,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 16560,
                        "time": 45.000074999999995,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 16560,
                        "time": 45.000074999999995,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 16656,
                        "time": 45.260945,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 16656,
                        "time": 45.260945,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 16752,
                        "time": 45.521815,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 16752,
                        "time": 45.521815,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 16800,
                        "time": 45.652249999999995,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 16800,
                        "time": 45.652249999999995,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 16896,
                        "time": 45.91312,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 16896,
                        "time": 45.91312,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 16992,
                        "time": 46.173989999999996,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 16992,
                        "time": 46.173989999999996,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 17088,
                        "time": 46.43486,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 17088,
                        "time": 46.43486,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 17136,
                        "time": 46.565295,
                        "velocity": 0.6614173228346457
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 17136,
                        "time": 46.565295,
                        "velocity": 0.6614173228346457
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 17232,
                        "time": 46.826164999999996,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 17232,
                        "time": 46.826164999999996,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 17328,
                        "time": 47.087035,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 17328,
                        "time": 47.087035,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 17424,
                        "time": 47.347905,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 17424,
                        "time": 47.347905,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 17520,
                        "time": 47.608775,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 17520,
                        "time": 47.608775,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 17568,
                        "time": 47.73921,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 17568,
                        "time": 47.73921,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 17664,
                        "time": 48.00008,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 17664,
                        "time": 48.00008,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 17760,
                        "time": 48.26095,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 17760,
                        "time": 48.26095,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 17856,
                        "time": 48.52182,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 17856,
                        "time": 48.52182,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 17904,
                        "time": 48.652255,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 17904,
                        "time": 48.652255,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 18000,
                        "time": 48.913125,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 18000,
                        "time": 48.913125,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 18096,
                        "time": 49.173995,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 18096,
                        "time": 49.173995,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 18192,
                        "time": 49.434864999999995,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 18192,
                        "time": 49.434864999999995,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 18288,
                        "time": 49.695735,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 18288,
                        "time": 49.695735,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 18336,
                        "time": 49.82617,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 18336,
                        "time": 49.82617,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 18432,
                        "time": 50.08704,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18432,
                        "time": 50.08704,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 18528,
                        "time": 50.34791,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18528,
                        "time": 50.34791,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 18624,
                        "time": 50.608779999999996,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18624,
                        "time": 50.608779999999996,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 18672,
                        "time": 50.739215,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18672,
                        "time": 50.739215,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 18768,
                        "time": 51.000085,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18768,
                        "time": 51.000085,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 18864,
                        "time": 51.260954999999996,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18864,
                        "time": 51.260954999999996,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 18960,
                        "time": 51.521825,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 18960,
                        "time": 51.521825,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 19056,
                        "time": 51.782695,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 19056,
                        "time": 51.782695,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 19104,
                        "time": 51.913129999999995,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 19104,
                        "time": 51.913129999999995,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 19200,
                        "time": 52.174,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 19200,
                        "time": 52.174,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 19296,
                        "time": 52.43487,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 19296,
                        "time": 52.43487,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 19392,
                        "time": 52.69574,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 19392,
                        "time": 52.69574,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 19440,
                        "time": 52.826175,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 19440,
                        "time": 52.826175,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 19536,
                        "time": 53.087044999999996,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 19536,
                        "time": 53.087044999999996,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 19632,
                        "time": 53.347915,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 19632,
                        "time": 53.347915,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 19728,
                        "time": 53.608785,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 19728,
                        "time": 53.608785,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 19824,
                        "time": 53.869655,
                        "velocity": 0.5511811023622047
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 19824,
                        "time": 53.869655,
                        "velocity": 0.5511811023622047
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 19872,
                        "time": 54.00009,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 19872,
                        "time": 54.00009,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 19968,
                        "time": 54.26096,
                        "velocity": 0.6614173228346457
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 19968,
                        "time": 54.26096,
                        "velocity": 0.6614173228346457
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 20064,
                        "time": 54.52183,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 20064,
                        "time": 54.52183,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 20160,
                        "time": 54.7827,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 20160,
                        "time": 54.7827,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 20208,
                        "time": 54.913135,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 20208,
                        "time": 54.913135,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 20304,
                        "time": 55.174005,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 20304,
                        "time": 55.174005,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 20400,
                        "time": 55.434875,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 20400,
                        "time": 55.434875,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 20496,
                        "time": 55.695744999999995,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 20496,
                        "time": 55.695744999999995,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 20592,
                        "time": 55.956615,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 20592,
                        "time": 55.956615,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 20640,
                        "time": 56.08705,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 20640,
                        "time": 56.08705,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 20736,
                        "time": 56.347919999999995,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 20736,
                        "time": 56.347919999999995,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 20832,
                        "time": 56.60879,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 20832,
                        "time": 56.60879,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 20928,
                        "time": 56.869659999999996,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 20928,
                        "time": 56.869659999999996,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 20976,
                        "time": 57.000094999999995,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 20976,
                        "time": 57.000094999999995,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 21072,
                        "time": 57.260965,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 21072,
                        "time": 57.260965,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 21168,
                        "time": 57.521834999999996,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 21168,
                        "time": 57.521834999999996,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 21264,
                        "time": 57.782705,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 21264,
                        "time": 57.782705,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 21360,
                        "time": 58.043575,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 21360,
                        "time": 58.043575,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 21408,
                        "time": 58.174009999999996,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 21408,
                        "time": 58.174009999999996,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 21504,
                        "time": 58.43488,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21504,
                        "time": 58.43488,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 21600,
                        "time": 58.69575,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21600,
                        "time": 58.69575,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21696,
                        "time": 58.95662,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 21696,
                        "time": 58.95662,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21744,
                        "time": 59.087055,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 21744,
                        "time": 59.087055,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21840,
                        "time": 59.347925,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 21840,
                        "time": 59.347925,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 21936,
                        "time": 59.608795,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 21936,
                        "time": 59.608795,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 22032,
                        "time": 59.869665,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 22032,
                        "time": 59.869665,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 22128,
                        "time": 60.130534999999995,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 22128,
                        "time": 60.130534999999995,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 22176,
                        "time": 60.26097,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 22176,
                        "time": 60.26097,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 22272,
                        "time": 60.52184,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 22272,
                        "time": 60.52184,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 22368,
                        "time": 60.782709999999994,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 22368,
                        "time": 60.782709999999994,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 22464,
                        "time": 61.04358,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 22464,
                        "time": 61.04358,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 22512,
                        "time": 61.174015,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 22512,
                        "time": 61.174015,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 22608,
                        "time": 61.434885,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 22608,
                        "time": 61.434885,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 22704,
                        "time": 61.695755,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 22704,
                        "time": 61.695755,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 22800,
                        "time": 61.956624999999995,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 22800,
                        "time": 61.956624999999995,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 22896,
                        "time": 62.217495,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 22896,
                        "time": 62.217495,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 22944,
                        "time": 62.34793,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 22944,
                        "time": 62.34793,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 23040,
                        "time": 62.608799999999995,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 23040,
                        "time": 62.608799999999995,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 23136,
                        "time": 62.86967,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 23136,
                        "time": 62.86967,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 23232,
                        "time": 63.130539999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043499999999852,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 23232,
                        "time": 63.130539999999996,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 23280,
                        "time": 63.260974999999995,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26087000000000415,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 23280,
                        "time": 63.260974999999995,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 23376,
                        "time": 63.521845,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 23376,
                        "time": 63.521845,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 23472,
                        "time": 63.782714999999996,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 23472,
                        "time": 63.782714999999996,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 23568,
                        "time": 64.043585,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 23568,
                        "time": 64.043585,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 23664,
                        "time": 64.304455,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 23664,
                        "time": 64.304455,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 23712,
                        "time": 64.43489,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 23712,
                        "time": 64.43489,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 23808,
                        "time": 64.69575999999999,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 23808,
                        "time": 64.69575999999999,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 23904,
                        "time": 64.95663,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 23904,
                        "time": 64.95663,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 24000,
                        "time": 65.2175,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 24000,
                        "time": 65.2175,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 24048,
                        "time": 65.34793499999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 24048,
                        "time": 65.34793499999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 24144,
                        "time": 65.608805,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 24144,
                        "time": 65.608805,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 24240,
                        "time": 65.869675,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 24240,
                        "time": 65.869675,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 24336,
                        "time": 66.130545,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 24336,
                        "time": 66.130545,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 24432,
                        "time": 66.391415,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 24432,
                        "time": 66.391415,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 24480,
                        "time": 66.52185,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 24480,
                        "time": 66.52185,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 24576,
                        "time": 66.78272,
                        "velocity": 0.5433070866141733
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24576,
                        "time": 66.78272,
                        "velocity": 0.5433070866141733
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 24672,
                        "time": 67.04359,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24672,
                        "time": 67.04359,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 24768,
                        "time": 67.30445999999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24768,
                        "time": 67.30445999999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 24816,
                        "time": 67.434895,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24816,
                        "time": 67.434895,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 24912,
                        "time": 67.695765,
                        "velocity": 0.5511811023622047
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 24912,
                        "time": 67.695765,
                        "velocity": 0.5511811023622047
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 25008,
                        "time": 67.95663499999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 25008,
                        "time": 67.95663499999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 25104,
                        "time": 68.217505,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 25104,
                        "time": 68.217505,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 25200,
                        "time": 68.478375,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 25200,
                        "time": 68.478375,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 25248,
                        "time": 68.60880999999999,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 25248,
                        "time": 68.60880999999999,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 25344,
                        "time": 68.86968,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 25344,
                        "time": 68.86968,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 25440,
                        "time": 69.13055,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 25440,
                        "time": 69.13055,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 25536,
                        "time": 69.39142,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 25536,
                        "time": 69.39142,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 25584,
                        "time": 69.521855,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 25584,
                        "time": 69.521855,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 25680,
                        "time": 69.782725,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 25680,
                        "time": 69.782725,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 25776,
                        "time": 70.043595,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 25776,
                        "time": 70.043595,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 25872,
                        "time": 70.304465,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 25872,
                        "time": 70.304465,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 25968,
                        "time": 70.565335,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 25968,
                        "time": 70.565335,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 26016,
                        "time": 70.69577,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 26016,
                        "time": 70.69577,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 26112,
                        "time": 70.95664,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 26112,
                        "time": 70.95664,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 26208,
                        "time": 71.21751,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 26208,
                        "time": 71.21751,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 26304,
                        "time": 71.47838,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 26304,
                        "time": 71.47838,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 26352,
                        "time": 71.60881499999999,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 26352,
                        "time": 71.60881499999999,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 26448,
                        "time": 71.869685,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 26448,
                        "time": 71.869685,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 26544,
                        "time": 72.130555,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 26544,
                        "time": 72.130555,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 26640,
                        "time": 72.391425,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 26640,
                        "time": 72.391425,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 26736,
                        "time": 72.652295,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 26736,
                        "time": 72.652295,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 26784,
                        "time": 72.78273,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 26784,
                        "time": 72.78273,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 26880,
                        "time": 73.0436,
                        "velocity": 0.5433070866141733
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 26880,
                        "time": 73.0436,
                        "velocity": 0.5433070866141733
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 26976,
                        "time": 73.30447,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 26976,
                        "time": 73.30447,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 27072,
                        "time": 73.56533999999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 27072,
                        "time": 73.56533999999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 27120,
                        "time": 73.695775,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 27120,
                        "time": 73.695775,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 27216,
                        "time": 73.956645,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 27216,
                        "time": 73.956645,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 27312,
                        "time": 74.21751499999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 27312,
                        "time": 74.21751499999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 27408,
                        "time": 74.478385,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 27408,
                        "time": 74.478385,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 27504,
                        "time": 74.739255,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 27504,
                        "time": 74.739255,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 27552,
                        "time": 74.86968999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 27552,
                        "time": 74.86968999999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 27648,
                        "time": 75.13056,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 27648,
                        "time": 75.13056,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 27744,
                        "time": 75.39143,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 27744,
                        "time": 75.39143,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 27840,
                        "time": 75.6523,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 27840,
                        "time": 75.6523,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 27888,
                        "time": 75.782735,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 27888,
                        "time": 75.782735,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 27984,
                        "time": 76.043605,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 27984,
                        "time": 76.043605,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 28080,
                        "time": 76.304475,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 28080,
                        "time": 76.304475,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 28176,
                        "time": 76.565345,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 28176,
                        "time": 76.565345,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 28272,
                        "time": 76.82621499999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 28272,
                        "time": 76.82621499999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 28320,
                        "time": 76.95665,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 28320,
                        "time": 76.95665,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 28416,
                        "time": 77.21752,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 28416,
                        "time": 77.21752,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 28512,
                        "time": 77.47838999999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 28512,
                        "time": 77.47838999999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 28608,
                        "time": 77.73926,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 28608,
                        "time": 77.73926,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 28656,
                        "time": 77.869695,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 28656,
                        "time": 77.869695,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 28752,
                        "time": 78.130565,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 28752,
                        "time": 78.130565,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 28848,
                        "time": 78.391435,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 28848,
                        "time": 78.391435,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 28944,
                        "time": 78.652305,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 28944,
                        "time": 78.652305,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 29040,
                        "time": 78.913175,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 29040,
                        "time": 78.913175,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 29088,
                        "time": 79.04361,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 29088,
                        "time": 79.04361,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 29184,
                        "time": 79.30448,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 29184,
                        "time": 79.30448,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 29280,
                        "time": 79.56535,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 29280,
                        "time": 79.56535,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 29376,
                        "time": 79.82621999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 29376,
                        "time": 79.82621999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 29424,
                        "time": 79.956655,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 29424,
                        "time": 79.956655,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 29520,
                        "time": 80.217525,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 29520,
                        "time": 80.217525,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 29616,
                        "time": 80.47839499999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 29616,
                        "time": 80.47839499999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 29712,
                        "time": 80.739265,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 29712,
                        "time": 80.739265,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 29808,
                        "time": 81.000135,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 29808,
                        "time": 81.000135,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 29856,
                        "time": 81.13056999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 29856,
                        "time": 81.13056999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 29952,
                        "time": 81.39144,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 29952,
                        "time": 81.39144,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 30048,
                        "time": 81.65231,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 30048,
                        "time": 81.65231,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 30144,
                        "time": 81.91318,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 30144,
                        "time": 81.91318,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 30192,
                        "time": 82.043615,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 30192,
                        "time": 82.043615,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 30288,
                        "time": 82.304485,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 30288,
                        "time": 82.304485,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 30384,
                        "time": 82.565355,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 30384,
                        "time": 82.565355,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 30480,
                        "time": 82.826225,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 30480,
                        "time": 82.826225,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 30576,
                        "time": 83.08709499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 30576,
                        "time": 83.08709499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 58,
                        "name": "A#3",
                        "ticks": 30624,
                        "time": 83.21753,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 51,
                        "name": "D#3",
                        "ticks": 30624,
                        "time": 83.21753,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 30720,
                        "time": 83.4784,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 30720,
                        "time": 83.4784,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 30816,
                        "time": 83.73926999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 30816,
                        "time": 83.73926999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 30912,
                        "time": 84.00014,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 30912,
                        "time": 84.00014,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 30960,
                        "time": 84.130575,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 30960,
                        "time": 84.130575,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 31056,
                        "time": 84.39144499999999,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 31056,
                        "time": 84.39144499999999,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 31152,
                        "time": 84.652315,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 31152,
                        "time": 84.652315,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 31248,
                        "time": 84.913185,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 31248,
                        "time": 84.913185,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 31344,
                        "time": 85.174055,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 31344,
                        "time": 85.174055,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 31392,
                        "time": 85.30449,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 31392,
                        "time": 85.30449,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 31488,
                        "time": 85.56536,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 31488,
                        "time": 85.56536,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 31584,
                        "time": 85.82623,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 31584,
                        "time": 85.82623,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 31680,
                        "time": 86.08709999999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 31680,
                        "time": 86.08709999999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 31728,
                        "time": 86.217535,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 31728,
                        "time": 86.217535,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 31824,
                        "time": 86.478405,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 31824,
                        "time": 86.478405,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 31920,
                        "time": 86.73927499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 31920,
                        "time": 86.73927499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 32016,
                        "time": 87.000145,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 32016,
                        "time": 87.000145,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 32112,
                        "time": 87.261015,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 32112,
                        "time": 87.261015,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 32160,
                        "time": 87.39144999999999,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 32160,
                        "time": 87.39144999999999,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 32256,
                        "time": 87.65232,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 32256,
                        "time": 87.65232,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 32352,
                        "time": 87.91319,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 32352,
                        "time": 87.91319,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 32448,
                        "time": 88.17406,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 32448,
                        "time": 88.17406,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 32496,
                        "time": 88.304495,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 32496,
                        "time": 88.304495,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 32592,
                        "time": 88.565365,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 32592,
                        "time": 88.565365,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 32688,
                        "time": 88.826235,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 32688,
                        "time": 88.826235,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 32784,
                        "time": 89.087105,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 32784,
                        "time": 89.087105,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 32880,
                        "time": 89.34797499999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 32880,
                        "time": 89.34797499999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 32928,
                        "time": 89.47841,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 32928,
                        "time": 89.47841,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 33024,
                        "time": 89.73928,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 33024,
                        "time": 89.73928,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 33120,
                        "time": 90.00014999999999,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 33120,
                        "time": 90.00014999999999,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 33216,
                        "time": 90.26102,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 33216,
                        "time": 90.26102,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 33264,
                        "time": 90.391455,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 33264,
                        "time": 90.391455,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 33360,
                        "time": 90.65232499999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 33360,
                        "time": 90.65232499999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 33456,
                        "time": 90.913195,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 33456,
                        "time": 90.913195,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 33552,
                        "time": 91.174065,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 33552,
                        "time": 91.174065,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 33648,
                        "time": 91.434935,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 33648,
                        "time": 91.434935,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 33696,
                        "time": 91.56537,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 33696,
                        "time": 91.56537,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 33792,
                        "time": 91.82624,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 33792,
                        "time": 91.82624,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 33888,
                        "time": 92.08711,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 33888,
                        "time": 92.08711,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 33984,
                        "time": 92.34797999999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 33984,
                        "time": 92.34797999999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 34032,
                        "time": 92.478415,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 34032,
                        "time": 92.478415,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 34128,
                        "time": 92.739285,
                        "velocity": 0.5511811023622047
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 34128,
                        "time": 92.739285,
                        "velocity": 0.5511811023622047
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 34224,
                        "time": 93.00015499999999,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 34224,
                        "time": 93.00015499999999,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 34320,
                        "time": 93.261025,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 34320,
                        "time": 93.261025,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 34416,
                        "time": 93.521895,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 34416,
                        "time": 93.521895,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 34464,
                        "time": 93.65232999999999,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 34464,
                        "time": 93.65232999999999,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 34512,
                        "time": 93.782765,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 34512,
                        "time": 93.782765,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 34560,
                        "time": 93.9132,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 34560,
                        "time": 93.9132,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 34656,
                        "time": 94.17407,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 34656,
                        "time": 94.17407,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 34752,
                        "time": 94.43494,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 34752,
                        "time": 94.43494,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 34800,
                        "time": 94.565375,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 34800,
                        "time": 94.565375,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 34896,
                        "time": 94.826245,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 34896,
                        "time": 94.826245,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 34992,
                        "time": 95.087115,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 34992,
                        "time": 95.087115,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 35088,
                        "time": 95.347985,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 35088,
                        "time": 95.347985,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 35184,
                        "time": 95.60885499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 35184,
                        "time": 95.60885499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 35232,
                        "time": 95.73929,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 35232,
                        "time": 95.73929,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 35328,
                        "time": 96.00016,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 35328,
                        "time": 96.00016,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 35424,
                        "time": 96.26102999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 35424,
                        "time": 96.26102999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 35520,
                        "time": 96.5219,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 35520,
                        "time": 96.5219,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 35568,
                        "time": 96.652335,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 35568,
                        "time": 96.652335,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 35664,
                        "time": 96.91320499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 35664,
                        "time": 96.91320499999999,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 35760,
                        "time": 97.174075,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 35760,
                        "time": 97.174075,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 35856,
                        "time": 97.434945,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 35856,
                        "time": 97.434945,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 35952,
                        "time": 97.695815,
                        "velocity": 0.5433070866141733
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 35952,
                        "time": 97.695815,
                        "velocity": 0.5433070866141733
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 36000,
                        "time": 97.82625,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 36000,
                        "time": 97.82625,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 36096,
                        "time": 98.08712,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 36096,
                        "time": 98.08712,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 36192,
                        "time": 98.34799,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 36192,
                        "time": 98.34799,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 36288,
                        "time": 98.60885999999999,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 36288,
                        "time": 98.60885999999999,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 36336,
                        "time": 98.739295,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 36336,
                        "time": 98.739295,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 36432,
                        "time": 99.000165,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 36432,
                        "time": 99.000165,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 36528,
                        "time": 99.26103499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 36528,
                        "time": 99.26103499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 36624,
                        "time": 99.52190499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 36624,
                        "time": 99.52190499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 36720,
                        "time": 99.782775,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 36720,
                        "time": 99.782775,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 36768,
                        "time": 99.91320999999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 36768,
                        "time": 99.91320999999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 36864,
                        "time": 100.17408,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 36864,
                        "time": 100.17408,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 36960,
                        "time": 100.43495,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 36960,
                        "time": 100.43495,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 37056,
                        "time": 100.69582,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 37056,
                        "time": 100.69582,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 37104,
                        "time": 100.826255,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 37104,
                        "time": 100.826255,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 37200,
                        "time": 101.087125,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 37200,
                        "time": 101.087125,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 37296,
                        "time": 101.347995,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 37296,
                        "time": 101.347995,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 37392,
                        "time": 101.608865,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 37392,
                        "time": 101.608865,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 37488,
                        "time": 101.86973499999999,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 37488,
                        "time": 101.86973499999999,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 37536,
                        "time": 102.00017,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 37536,
                        "time": 102.00017,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 37632,
                        "time": 102.26104,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 37632,
                        "time": 102.26104,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 37728,
                        "time": 102.52190999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 37728,
                        "time": 102.52190999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 37824,
                        "time": 102.78278,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 37824,
                        "time": 102.78278,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 37872,
                        "time": 102.913215,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 37872,
                        "time": 102.913215,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 37968,
                        "time": 103.17408499999999,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 37968,
                        "time": 103.17408499999999,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 38064,
                        "time": 103.434955,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 38064,
                        "time": 103.434955,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 38160,
                        "time": 103.695825,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 38160,
                        "time": 103.695825,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 38256,
                        "time": 103.956695,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 38256,
                        "time": 103.956695,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 38304,
                        "time": 104.08713,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 38304,
                        "time": 104.08713,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 38400,
                        "time": 104.348,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 38400,
                        "time": 104.348,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 38496,
                        "time": 104.60887,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 38496,
                        "time": 104.60887,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 38592,
                        "time": 104.86974,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 38592,
                        "time": 104.86974,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 38640,
                        "time": 105.000175,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 38640,
                        "time": 105.000175,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 38736,
                        "time": 105.261045,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 38736,
                        "time": 105.261045,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 38832,
                        "time": 105.52191499999999,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 38832,
                        "time": 105.52191499999999,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 38928,
                        "time": 105.78278499999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 38928,
                        "time": 105.78278499999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 39024,
                        "time": 106.043655,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 39024,
                        "time": 106.043655,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 39072,
                        "time": 106.17408999999999,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 39072,
                        "time": 106.17408999999999,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 39168,
                        "time": 106.43495999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 39168,
                        "time": 106.43495999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 39264,
                        "time": 106.69583,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 39264,
                        "time": 106.69583,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 39360,
                        "time": 106.9567,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 39360,
                        "time": 106.9567,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 39408,
                        "time": 107.08713499999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 39408,
                        "time": 107.08713499999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 39504,
                        "time": 107.348005,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 39504,
                        "time": 107.348005,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 39600,
                        "time": 107.608875,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 39600,
                        "time": 107.608875,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 39696,
                        "time": 107.869745,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 39696,
                        "time": 107.869745,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 39792,
                        "time": 108.13061499999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 39792,
                        "time": 108.13061499999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 39840,
                        "time": 108.26105,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 39840,
                        "time": 108.26105,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 39936,
                        "time": 108.52192,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 39936,
                        "time": 108.52192,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 40032,
                        "time": 108.78278999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 40032,
                        "time": 108.78278999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 40128,
                        "time": 109.04366,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 40128,
                        "time": 109.04366,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 40176,
                        "time": 109.174095,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 40176,
                        "time": 109.174095,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 40272,
                        "time": 109.43496499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 40272,
                        "time": 109.43496499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 40368,
                        "time": 109.695835,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 40368,
                        "time": 109.695835,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 40464,
                        "time": 109.956705,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 40464,
                        "time": 109.956705,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 40560,
                        "time": 110.217575,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 40560,
                        "time": 110.217575,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 40608,
                        "time": 110.34801,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 40608,
                        "time": 110.34801,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 40704,
                        "time": 110.60888,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 40704,
                        "time": 110.60888,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 40800,
                        "time": 110.86975,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 40800,
                        "time": 110.86975,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 40896,
                        "time": 111.13062,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 40896,
                        "time": 111.13062,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 40944,
                        "time": 111.261055,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 40944,
                        "time": 111.261055,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 41040,
                        "time": 111.521925,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 41040,
                        "time": 111.521925,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 41136,
                        "time": 111.782795,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 41136,
                        "time": 111.782795,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 41232,
                        "time": 112.04366499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 41232,
                        "time": 112.04366499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 41328,
                        "time": 112.304535,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 41328,
                        "time": 112.304535,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 41376,
                        "time": 112.43496999999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 41376,
                        "time": 112.43496999999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 41472,
                        "time": 112.69583999999999,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 41472,
                        "time": 112.69583999999999,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 41472,
                        "time": 112.69583999999999,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 41520,
                        "time": 112.826275,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 41520,
                        "time": 112.826275,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 41520,
                        "time": 112.826275,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 42240,
                        "time": 114.7828,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 42240,
                        "time": 114.7828,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 42240,
                        "time": 114.7828,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 42288,
                        "time": 114.913235,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 62,
                        "name": "D4",
                        "ticks": 42288,
                        "time": 114.913235,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 42288,
                        "time": 114.913235,
                        "velocity": 0.6535433070866141
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 42672,
                        "time": 115.956715,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 42672,
                        "time": 115.956715,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 42768,
                        "time": 116.217585,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 42768,
                        "time": 116.217585,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 42864,
                        "time": 116.478455,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 42864,
                        "time": 116.478455,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 42912,
                        "time": 116.60889,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 42912,
                        "time": 116.60889,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 43008,
                        "time": 116.86976,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43008,
                        "time": 116.86976,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43104,
                        "time": 117.13063,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 43104,
                        "time": 117.13063,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 43200,
                        "time": 117.3915,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43200,
                        "time": 117.3915,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 43248,
                        "time": 117.521935,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43248,
                        "time": 117.521935,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43344,
                        "time": 117.782805,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 43344,
                        "time": 117.782805,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 43440,
                        "time": 118.043675,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43440,
                        "time": 118.043675,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43536,
                        "time": 118.30454499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 43536,
                        "time": 118.30454499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 43632,
                        "time": 118.565415,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43632,
                        "time": 118.565415,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 43680,
                        "time": 118.69585,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 43680,
                        "time": 118.69585,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 43776,
                        "time": 118.95671999999999,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 43776,
                        "time": 118.95671999999999,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 43872,
                        "time": 119.21759,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 43872,
                        "time": 119.21759,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 43968,
                        "time": 119.47846,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 43968,
                        "time": 119.47846,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 44016,
                        "time": 119.60889499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 44016,
                        "time": 119.60889499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 44112,
                        "time": 119.869765,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 44112,
                        "time": 119.869765,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 44208,
                        "time": 120.130635,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 44208,
                        "time": 120.130635,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 44304,
                        "time": 120.391505,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 44304,
                        "time": 120.391505,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 44400,
                        "time": 120.65237499999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 44400,
                        "time": 120.65237499999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 44448,
                        "time": 120.78281,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 44448,
                        "time": 120.78281,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 44544,
                        "time": 121.04368,
                        "velocity": 0.6692913385826772
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 44544,
                        "time": 121.04368,
                        "velocity": 0.6692913385826772
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 44640,
                        "time": 121.30454999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 44640,
                        "time": 121.30454999999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 44736,
                        "time": 121.56541999999999,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 44736,
                        "time": 121.56541999999999,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 44784,
                        "time": 121.695855,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 44784,
                        "time": 121.695855,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 44880,
                        "time": 121.95672499999999,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 44880,
                        "time": 121.95672499999999,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 44976,
                        "time": 122.21759499999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 44976,
                        "time": 122.21759499999999,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 45072,
                        "time": 122.478465,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 45072,
                        "time": 122.478465,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 45168,
                        "time": 122.739335,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 45168,
                        "time": 122.739335,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 45216,
                        "time": 122.86977,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 45216,
                        "time": 122.86977,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 45312,
                        "time": 123.13064,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 45312,
                        "time": 123.13064,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 45408,
                        "time": 123.39151,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 45408,
                        "time": 123.39151,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 45504,
                        "time": 123.65238,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 45504,
                        "time": 123.65238,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 45552,
                        "time": 123.782815,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 45552,
                        "time": 123.782815,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 45648,
                        "time": 124.043685,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 45648,
                        "time": 124.043685,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 45744,
                        "time": 124.304555,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 45744,
                        "time": 124.304555,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 45840,
                        "time": 124.56542499999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 45840,
                        "time": 124.56542499999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 45936,
                        "time": 124.826295,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 45936,
                        "time": 124.826295,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 45984,
                        "time": 124.95673,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 45984,
                        "time": 124.95673,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 46080,
                        "time": 125.21759999999999,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46080,
                        "time": 125.21759999999999,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46176,
                        "time": 125.47847,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 46176,
                        "time": 125.47847,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 46272,
                        "time": 125.73934,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043499999999142,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46272,
                        "time": 125.73934,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 46320,
                        "time": 125.86977499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46320,
                        "time": 125.86977499999999,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46416,
                        "time": 126.130645,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 46416,
                        "time": 126.130645,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 46512,
                        "time": 126.391515,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46512,
                        "time": 126.391515,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46608,
                        "time": 126.652385,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 46608,
                        "time": 126.652385,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 46704,
                        "time": 126.91325499999999,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46704,
                        "time": 126.91325499999999,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 46752,
                        "time": 127.04369,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 46752,
                        "time": 127.04369,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 46848,
                        "time": 127.30456,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 46848,
                        "time": 127.30456,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 46944,
                        "time": 127.56542999999999,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 46944,
                        "time": 127.56542999999999,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 47040,
                        "time": 127.82629999999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 47040,
                        "time": 127.82629999999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 47088,
                        "time": 127.956735,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999999705,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 47088,
                        "time": 127.956735,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 47184,
                        "time": 128.217605,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 47184,
                        "time": 128.217605,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 47280,
                        "time": 128.478475,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 47280,
                        "time": 128.478475,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 47376,
                        "time": 128.739345,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 47376,
                        "time": 128.739345,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 47472,
                        "time": 129.000215,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 47472,
                        "time": 129.000215,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 47520,
                        "time": 129.13065,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 47520,
                        "time": 129.13065,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 47616,
                        "time": 129.39151999999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 47616,
                        "time": 129.39151999999999,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 47712,
                        "time": 129.65239,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 47712,
                        "time": 129.65239,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 47808,
                        "time": 129.91326,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 47808,
                        "time": 129.91326,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 47856,
                        "time": 130.04369499999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 47856,
                        "time": 130.04369499999999,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 47952,
                        "time": 130.304565,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 47952,
                        "time": 130.304565,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 48048,
                        "time": 130.565435,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 48048,
                        "time": 130.565435,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 48144,
                        "time": 130.826305,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 48144,
                        "time": 130.826305,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 48240,
                        "time": 131.087175,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 48240,
                        "time": 131.087175,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 48288,
                        "time": 131.21761,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 48288,
                        "time": 131.21761,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 48384,
                        "time": 131.47848,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 48384,
                        "time": 131.47848,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 48480,
                        "time": 131.73935,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 48480,
                        "time": 131.73935,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 48576,
                        "time": 132.00021999999998,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 48576,
                        "time": 132.00021999999998,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 48624,
                        "time": 132.130655,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 48624,
                        "time": 132.130655,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 48720,
                        "time": 132.391525,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 48720,
                        "time": 132.391525,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 48816,
                        "time": 132.65239499999998,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 48816,
                        "time": 132.65239499999998,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 48912,
                        "time": 132.913265,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 48912,
                        "time": 132.913265,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 49008,
                        "time": 133.174135,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 49008,
                        "time": 133.174135,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 49056,
                        "time": 133.30456999999998,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 49056,
                        "time": 133.30456999999998,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 49152,
                        "time": 133.56544,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49152,
                        "time": 133.56544,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49248,
                        "time": 133.82631,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 49248,
                        "time": 133.82631,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 49344,
                        "time": 134.08718,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49344,
                        "time": 134.08718,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 49392,
                        "time": 134.217615,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49392,
                        "time": 134.217615,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49488,
                        "time": 134.478485,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 49488,
                        "time": 134.478485,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 49584,
                        "time": 134.739355,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49584,
                        "time": 134.739355,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49680,
                        "time": 135.000225,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 49680,
                        "time": 135.000225,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 49776,
                        "time": 135.26109499999998,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49776,
                        "time": 135.26109499999998,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 49824,
                        "time": 135.39153,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 49824,
                        "time": 135.39153,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 49920,
                        "time": 135.6524,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 49920,
                        "time": 135.6524,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 50016,
                        "time": 135.91326999999998,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 50016,
                        "time": 135.91326999999998,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 50112,
                        "time": 136.17414,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 50112,
                        "time": 136.17414,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 50160,
                        "time": 136.304575,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 50160,
                        "time": 136.304575,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 50256,
                        "time": 136.56544499999998,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 50256,
                        "time": 136.56544499999998,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 50352,
                        "time": 136.826315,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 50352,
                        "time": 136.826315,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 50448,
                        "time": 137.087185,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 50448,
                        "time": 137.087185,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 50544,
                        "time": 137.348055,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 50544,
                        "time": 137.348055,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 50592,
                        "time": 137.47849,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 50592,
                        "time": 137.47849,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 50688,
                        "time": 137.73936,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 50688,
                        "time": 137.73936,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 50784,
                        "time": 138.00023,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 50784,
                        "time": 138.00023,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 50880,
                        "time": 138.2611,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 50880,
                        "time": 138.2611,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 50928,
                        "time": 138.391535,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 50928,
                        "time": 138.391535,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 51024,
                        "time": 138.652405,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 51024,
                        "time": 138.652405,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 51120,
                        "time": 138.913275,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 51120,
                        "time": 138.913275,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 51216,
                        "time": 139.17414499999998,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 51216,
                        "time": 139.17414499999998,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 51312,
                        "time": 139.435015,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 51312,
                        "time": 139.435015,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 49,
                        "name": "C#3",
                        "ticks": 51360,
                        "time": 139.56545,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 56,
                        "name": "G#3",
                        "ticks": 51360,
                        "time": 139.56545,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 51456,
                        "time": 139.82631999999998,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 51456,
                        "time": 139.82631999999998,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 51552,
                        "time": 140.08719,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 51552,
                        "time": 140.08719,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 51648,
                        "time": 140.34806,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 51648,
                        "time": 140.34806,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 51696,
                        "time": 140.47849499999998,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 51696,
                        "time": 140.47849499999998,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 51792,
                        "time": 140.739365,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 51792,
                        "time": 140.739365,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 51888,
                        "time": 141.000235,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 51888,
                        "time": 141.000235,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 51984,
                        "time": 141.261105,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 51984,
                        "time": 141.261105,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 52080,
                        "time": 141.521975,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 52080,
                        "time": 141.521975,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 47,
                        "name": "B2",
                        "ticks": 52128,
                        "time": 141.65241,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 52128,
                        "time": 141.65241,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 52224,
                        "time": 141.91328,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52224,
                        "time": 141.91328,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52320,
                        "time": 142.17415,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 52320,
                        "time": 142.17415,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 52416,
                        "time": 142.43502,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52416,
                        "time": 142.43502,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 52464,
                        "time": 142.565455,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52464,
                        "time": 142.565455,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52560,
                        "time": 142.826325,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 52560,
                        "time": 142.826325,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 52656,
                        "time": 143.087195,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52656,
                        "time": 143.087195,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52752,
                        "time": 143.348065,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 52752,
                        "time": 143.348065,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 52848,
                        "time": 143.608935,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52848,
                        "time": 143.608935,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 46,
                        "name": "A#2",
                        "ticks": 52896,
                        "time": 143.73937,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 53,
                        "name": "F3",
                        "ticks": 52896,
                        "time": 143.73937,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 52992,
                        "time": 144.00024,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 52992,
                        "time": 144.00024,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 53088,
                        "time": 144.26111,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 53088,
                        "time": 144.26111,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 53184,
                        "time": 144.52197999999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 53184,
                        "time": 144.52197999999999,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 53232,
                        "time": 144.652415,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 53232,
                        "time": 144.652415,
                        "velocity": 0.6456692913385826
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 53328,
                        "time": 144.913285,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 53328,
                        "time": 144.913285,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 53424,
                        "time": 145.17415499999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 53424,
                        "time": 145.17415499999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 53520,
                        "time": 145.435025,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 53520,
                        "time": 145.435025,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 53616,
                        "time": 145.695895,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.1304349999999772,
                        "durationTicks": 48,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 53616,
                        "time": 145.695895,
                        "velocity": 0.6062992125984252
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 48,
                        "name": "C3",
                        "ticks": 53664,
                        "time": 145.82632999999998,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 55,
                        "name": "G3",
                        "ticks": 53664,
                        "time": 145.82632999999998,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 53760,
                        "time": 146.0872,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 53760,
                        "time": 146.0872,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 53856,
                        "time": 146.34807,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 53856,
                        "time": 146.34807,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 53952,
                        "time": 146.60894,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 53952,
                        "time": 146.60894,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 54000,
                        "time": 146.739375,
                        "velocity": 0.5511811023622047
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 54000,
                        "time": 146.739375,
                        "velocity": 0.5511811023622047
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 54096,
                        "time": 147.000245,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 54096,
                        "time": 147.000245,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 54192,
                        "time": 147.261115,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 54192,
                        "time": 147.261115,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 54288,
                        "time": 147.521985,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 54288,
                        "time": 147.521985,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 54384,
                        "time": 147.78285499999998,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 54384,
                        "time": 147.78285499999998,
                        "velocity": 0.5669291338582677
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 54432,
                        "time": 147.91329,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 54432,
                        "time": 147.91329,
                        "velocity": 0.6141732283464567
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 54528,
                        "time": 148.17416,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 54528,
                        "time": 148.17416,
                        "velocity": 0.5984251968503937
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 54624,
                        "time": 148.43502999999998,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 54624,
                        "time": 148.43502999999998,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 54720,
                        "time": 148.6959,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 54720,
                        "time": 148.6959,
                        "velocity": 0.5748031496062992
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 54768,
                        "time": 148.826335,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 54768,
                        "time": 148.826335,
                        "velocity": 0.6377952755905512
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 54864,
                        "time": 149.08720499999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 54864,
                        "time": 149.08720499999998,
                        "velocity": 0.6299212598425197
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 54960,
                        "time": 149.348075,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 54960,
                        "time": 149.348075,
                        "velocity": 0.6220472440944882
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 55056,
                        "time": 149.608945,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.26086999999998284,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 55056,
                        "time": 149.608945,
                        "velocity": 0.5590551181102362
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 55152,
                        "time": 149.869815,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.13043500000000563,
                        "durationTicks": 48,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 55152,
                        "time": 149.869815,
                        "velocity": 0.5905511811023622
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 50,
                        "name": "D3",
                        "ticks": 55200,
                        "time": 150.00025,
                        "velocity": 0.5826771653543307
                    },
                    {
                        "duration": 0.26087000000001126,
                        "durationTicks": 96,
                        "midi": 57,
                        "name": "A3",
                        "ticks": 55200,
                        "time": 150.00025,
                        "velocity": 0.5826771653543307
                    }
                ],
                "endOfTrackTicks": 55296
            }
        ]
    }
};
